(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flex-buy-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlexBuybox1 = (root) => {
      if (!root || root.dataset.flexBuybox1Initialized === 'true') return;
      root.dataset.flexBuybox1Initialized = 'true';

      const deferredKachingContainers = Array.from(
        root.querySelectorAll('[data-kaching-deferred]')
      );
      const kachingVisibilityTarget =
        root.querySelector('#bundle') || deferredKachingContainers[0] || null;
      let kachingVisibilityObserver = null;

      const hydrateKachingContainer = (container) => {
        if (!container || !container.hasAttribute('data-kaching-deferred')) return;

        const template = container.querySelector('[data-kaching-template]');
        if (!template) return;

        container.appendChild(template.content.cloneNode(true));
        template.remove();
        container.removeAttribute('data-kaching-deferred');
      };

      const hydrateAllKachingContainers = () => {
        deferredKachingContainers.forEach(hydrateKachingContainer);
        kachingVisibilityObserver?.disconnect();
      };

      root.addEventListener('fb1:hydrate-kaching', hydrateAllKachingContainers);

      if (deferredKachingContainers.length > 0) {
        if (window.Shopify?.designMode || window.location.hash === '#bundle') {
          hydrateAllKachingContainers();
        } else if ('IntersectionObserver' in window) {
          /*
            Kaching wird rechtzeitig vor dem Sichtbereich erzeugt. Auf mobilen
            Landingpages konkurriert ein noch weit unten liegendes Widget so
            nicht mit Hauptbild, Tracking und dem ersten Seitenaufbau.
          */
          kachingVisibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  hydrateAllKachingContainers();
                }
              });
            },
            {
              rootMargin: '600px 0px',
              threshold: 0,
            }
          );

          kachingVisibilityObserver.observe(kachingVisibilityTarget);
        } else {
          window.requestAnimationFrame(hydrateAllKachingContainers);
        }
      }

      const mediaButtons = Array.from(root.querySelectorAll('[data-media-target]'));
      const thumbnailStrip = root.querySelector('.fb1-thumbnails');
      const mediaPanels = Array.from(root.querySelectorAll('[data-media-id]'));
      const mainMedia = root.querySelector('.fb1-main-media');
      const galleryImages = Array.from(
        root.querySelectorAll('.fb1-media-panel img')
      );
      const galleryVideos = Array.from(
        root.querySelectorAll('[data-fb1-gallery-video]')
      );
      const externalGalleryVideos = Array.from(
        root.querySelectorAll('[data-fb1-external-video]')
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const deliveryTimeline = root.querySelector('[data-delivery-timeline]');

      const initializeDeliveryTimeline = () => {
        if (!deliveryTimeline || deliveryTimeline.dataset.dateMode !== 'automatic') return;

        const orderedDate = deliveryTimeline.querySelector(
          '[data-delivery-date="ordered"]'
        );
        const processingDate = deliveryTimeline.querySelector(
          '[data-delivery-date="processing"]'
        );
        const arrivalDate = deliveryTimeline.querySelector(
          '[data-delivery-date="arrival"]'
        );

        const usesBusinessDays = deliveryTimeline.dataset.businessDays === 'true';
        const safeInteger = (value, fallback) => {
          const parsedValue = Number.parseInt(value, 10);
          return Number.isFinite(parsedValue) && parsedValue >= 0
            ? parsedValue
            : fallback;
        };

        const processingStart = safeInteger(
          deliveryTimeline.dataset.processingMin,
          1
        );
        const processingEnd = Math.max(
          processingStart,
          safeInteger(deliveryTimeline.dataset.processingMax, 2)
        );
        const arrivalStart = safeInteger(deliveryTimeline.dataset.arrivalMin, 7);
        const arrivalEnd = Math.max(
          arrivalStart,
          safeInteger(deliveryTimeline.dataset.arrivalMax, 9)
        );

        const today = new Date();
        today.setHours(12, 0, 0, 0);

        const addDeliveryDays = (sourceDate, dayCount) => {
          const date = new Date(sourceDate);

          if (!usesBusinessDays) {
            date.setDate(date.getDate() + dayCount);
            return date;
          }

          let remainingDays = dayCount;

          while (remainingDays > 0) {
            date.setDate(date.getDate() + 1);
            const weekday = date.getDay();
            if (weekday !== 0 && weekday !== 6) remainingDays -= 1;
          }

          return date;
        };

        const locale = root.dataset.locale || 'de-DE';
        const dateFormatter = new Intl.DateTimeFormat(locale, {
          day: 'numeric',
          month: 'short',
        });
        const monthFormatter = new Intl.DateTimeFormat(locale, {
          month: 'short',
        });
        const formatDate = (date) => dateFormatter.format(date).replace(',', '');
        const formatRange = (minimum, maximum) => {
          const firstDate = addDeliveryDays(today, minimum);
          const lastDate = addDeliveryDays(today, maximum);

          if (firstDate.getTime() === lastDate.getTime()) {
            return formatDate(firstDate);
          }

          if (
            firstDate.getFullYear() === lastDate.getFullYear() &&
            firstDate.getMonth() === lastDate.getMonth()
          ) {
            return `${firstDate.getDate()}.–${lastDate.getDate()}. ${monthFormatter.format(lastDate)}`;
          }

          return `${firstDate.getDate()}.${firstDate.getMonth() + 1}.–${lastDate.getDate()}.${lastDate.getMonth() + 1}.`;
        };

        if (orderedDate) orderedDate.textContent = `Heute, ${formatDate(today)}`;
        if (processingDate) {
          processingDate.textContent = formatRange(processingStart, processingEnd);
        }
        if (arrivalDate) {
          arrivalDate.textContent = formatRange(arrivalStart, arrivalEnd);
        }
      };

      initializeDeliveryTimeline();

      const initializeReviewCarousel = () => {
        const viewport = root.querySelector('[data-review-viewport]');
        if (!viewport) return;

        const slides = Array.from(viewport.querySelectorAll('[data-review-slide]'));
        const previousButton = root.querySelector('[data-review-previous]');
        const nextButton = root.querySelector('[data-review-next]');

        if (slides.length < 2 || !previousButton || !nextButton) return;

        let syncFrame = 0;

        const syncReviewArrows = () => {
          syncFrame = 0;

          const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          const tolerance = Math.max(2, viewport.clientWidth * .02);
          const isAtStart = viewport.scrollLeft <= tolerance;
          const isAtEnd = viewport.scrollLeft >= maximumScroll - tolerance;

          previousButton.hidden = isAtStart;
          previousButton.disabled = isAtStart;
          nextButton.hidden = isAtEnd;
          nextButton.disabled = isAtEnd;
        };

        const requestArrowSync = () => {
          if (syncFrame) return;
          syncFrame = window.requestAnimationFrame(syncReviewArrows);
        };

        const moveReview = (direction) => {
          const viewportWidth = Math.max(viewport.clientWidth, 1);
          const currentIndex = Math.round(viewport.scrollLeft / viewportWidth);
          const targetIndex = Math.min(
            slides.length - 1,
            Math.max(0, currentIndex + direction)
          );

          viewport.scrollTo({
            left: slides[targetIndex].offsetLeft,
            behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
          });
        };

        viewport.addEventListener('scroll', requestArrowSync, { passive: true });
        previousButton.addEventListener('click', () => moveReview(-1));
        nextButton.addEventListener('click', () => moveReview(1));

        if ('ResizeObserver' in window) {
          const reviewResizeObserver = new ResizeObserver(requestArrowSync);
          reviewResizeObserver.observe(viewport);
        } else {
          window.addEventListener('resize', requestArrowSync, { passive: true });
        }

        syncReviewArrows();
      };

      initializeReviewCarousel();

      const primePanelImage = (panel) => {
        const image = panel?.querySelector('img');
        if (!image) return;

        image.loading = 'eager';

        if ('fetchPriority' in image) {
          image.fetchPriority = 'high';
        }

        if (image.complete && typeof image.decode === 'function') {
          image.decode().catch(() => {});
        }
      };

      let activeMediaIndex = mediaPanels.findIndex(
        (panel) => panel.classList.contains('is-active') && !panel.hidden
      );
      let isMediaAnimating = false;
      let swipeState = null;

      if (activeMediaIndex < 0 && mediaPanels.length > 0) {
        activeMediaIndex = 0;
      }

      const wrappedMediaIndex = (index) => {
        if (!mediaPanels.length) return -1;
        return (index + mediaPanels.length) % mediaPanels.length;
      };

      const safelyResetNativeVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /*
            currentTime kann vor dem ersten Laden noch nicht gesetzt werden.
            Das Video bleibt trotzdem pausiert und wird beim Aktivieren auf 0 gesetzt.
          */
        }
      };

      const sendExternalVideoCommand = (iframe, command, value) => {
        if (!iframe?.contentWindow) return;

        const host = iframe.dataset.fb1VideoHost;

        if (host === 'youtube') {
          const args = typeof value === 'undefined' ? [] : [value];
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: command,
              args,
            }),
            '*'
          );
          return;
        }

        if (host === 'vimeo') {
          const payload = { method: command };
          if (typeof value !== 'undefined') payload.value = value;
          iframe.contentWindow.postMessage(payload, '*');
        }
      };

      const registerExternalVideoEvents = (iframe) => {
        if (!iframe || iframe.dataset.fb1EventsRegistered === 'true') return;
        iframe.dataset.fb1EventsRegistered = 'true';

        if (iframe.dataset.fb1VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'onStateChange');
        } else if (iframe.dataset.fb1VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'ended');
        }
      };

      const loadExternalVideo = (iframe) =>
        new Promise((resolve) => {
          if (!iframe) {
            resolve();
            return;
          }

          if (iframe.dataset.fb1Loaded === 'true') {
            resolve();
            return;
          }

          const source = iframe.dataset.src;
          if (!source) {
            resolve();
            return;
          }

          const finish = () => {
            iframe.dataset.fb1Loaded = 'true';
            registerExternalVideoEvents(iframe);
            resolve();
          };

          iframe.addEventListener('load', finish, { once: true });
          iframe.src = source;
        });

      const resetExternalVideo = (iframe) => {
        if (!iframe) return;

        iframe.dataset.fb1PlayToken = String(
          (Number(iframe.dataset.fb1PlayToken) || 0) + 1
        );

        if (iframe.dataset.fb1Loaded !== 'true') return;

        if (iframe.dataset.fb1VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'pauseVideo');
          sendExternalVideoCommand(iframe, 'seekTo', 0);
        } else if (iframe.dataset.fb1VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'pause');
          sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
        }
      };

      const playExternalVideo = async (iframe) => {
        if (!iframe) return;

        const playToken = String(
          (Number(iframe.dataset.fb1PlayToken) || 0) + 1
        );
        iframe.dataset.fb1PlayToken = playToken;

        await loadExternalVideo(iframe);

        const panel = iframe.closest('.fb1-media-panel');
        if (
          iframe.dataset.fb1PlayToken !== playToken ||
          !panel?.classList.contains('is-active') ||
          panel.hidden
        ) {
          return;
        }

        iframe.closest('.fb1-external-video-shell')?.classList.add('is-loaded');

        const play = () => {
          if (
            iframe.dataset.fb1PlayToken !== playToken ||
            !panel.classList.contains('is-active') ||
            panel.hidden
          ) {
            return;
          }

          if (iframe.dataset.fb1VideoHost === 'youtube') {
            sendExternalVideoCommand(iframe, 'mute');
            sendExternalVideoCommand(iframe, 'seekTo', 0);
            sendExternalVideoCommand(iframe, 'playVideo');
          } else if (iframe.dataset.fb1VideoHost === 'vimeo') {
            sendExternalVideoCommand(iframe, 'setVolume', 0);
            sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
            sendExternalVideoCommand(iframe, 'play');
          }
        };

        /*
          Einige externe Player benötigen nach dem iframe-load einen kurzen
          Moment, bevor sie API-Befehle annehmen. Die Wiederholung ist stumm
          und unsichtbar, erhöht aber die Zuverlässigkeit deutlich.
        */
        play();
        window.setTimeout(play, 180);
        window.setTimeout(play, 500);
      };

      const playNativeGalleryVideo = (video) => {
        if (!video) return;

        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
        video.preload = 'auto';

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Das Abspielen startet nach dem ersten Laden automatisch bei 0. */
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      galleryVideos.forEach((video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'none';

        video.addEventListener('ended', () => {
          const panel = video.closest('.fb1-media-panel');
          const shouldRestart =
            panel?.classList.contains('is-active') &&
            panel.hidden === false &&
            mainMedia?.dataset.fb1Visible === 'true' &&
            document.visibilityState !== 'hidden';

          if (!shouldRestart) {
            safelyResetNativeVideo(video);
            return;
          }

          try {
            video.currentTime = 0;
          } catch (error) {
            /* Der native Loop übernimmt den Neustart, sobald die Datei bereit ist. */
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      });

      const onExternalVideoMessage = (event) => {
        const iframe = externalGalleryVideos.find(
          (candidate) => candidate.contentWindow === event.source
        );
        if (!iframe) return;

        let payload = event.data;

        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (error) {
            return;
          }
        }

        const youtubeEnded =
          iframe.dataset.fb1VideoHost === 'youtube' &&
          payload?.event === 'onStateChange' &&
          Number(payload.info) === 0;

        const vimeoEnded =
          iframe.dataset.fb1VideoHost === 'vimeo' &&
          payload?.event === 'ended';

        if (youtubeEnded || vimeoEnded) {
          const panel = iframe.closest('.fb1-media-panel');
          const shouldRestart =
            panel?.classList.contains('is-active') &&
            panel.hidden === false &&
            mainMedia?.dataset.fb1Visible === 'true' &&
            document.visibilityState !== 'hidden';

          if (shouldRestart) {
            playExternalVideo(iframe);
          } else {
            resetExternalVideo(iframe);
          }
        }
      };

      if (externalGalleryVideos.length > 0) {
        window.addEventListener('message', onExternalVideoMessage);
      }

      const pausePanelVideos = (panel) => {
        if (!panel) return;

        panel.querySelectorAll('[data-fb1-gallery-video]').forEach((video) => {
          safelyResetNativeVideo(video);
        });

        panel.querySelectorAll('[data-fb1-external-video]').forEach((iframe) => {
          resetExternalVideo(iframe);
        });
      };

      const activatePanelMedia = (panel) => {
        if (!panel) return;

        primePanelImage(panel);

        if (mainMedia && mainMedia.dataset.fb1Visible !== 'true') {
          return;
        }

        panel.querySelectorAll('[data-fb1-gallery-video]').forEach((video) => {
          playNativeGalleryVideo(video);
        });

        panel.querySelectorAll('[data-fb1-external-video]').forEach((iframe) => {
          playExternalVideo(iframe);
        });
      };

      const scrollThumbnailStrip = (activeButton) => {
        if (!thumbnailStrip || !activeButton || mediaButtons.length < 2) return;

        const activeButtonIndex = mediaButtons.indexOf(activeButton);

        if (activeButtonIndex < 0) return;

        /*
          Beim üblichen Start mit dem ersten Medium ist kein Scrollen nötig.
          So erzwingt die Initialisierung vor dem LCP keine Layout-Berechnung.
        */
        if (activeButtonIndex === 0 && thumbnailStrip.scrollLeft === 0) return;

        const firstButton = mediaButtons[0];
        const lastButton = mediaButtons[mediaButtons.length - 1];
        const firstRect = firstButton.getBoundingClientRect();
        const stripRect = thumbnailStrip.getBoundingClientRect();
        const stripStyles = window.getComputedStyle(thumbnailStrip);
        const gap = Number.parseFloat(stripStyles.columnGap || stripStyles.gap) || 0;
        const buttonWidth = firstRect.width;
        const step = buttonWidth + gap;

        if (buttonWidth <= 0 || step <= 0 || thumbnailStrip.clientWidth <= 0) return;

        /*
          Nur vollständig sichtbare Vorschaubilder zählen. Das rechts
          angeschnittene Vorschaubild zählt nicht als vollständige Position.
        */
        const visibleThumbnailCount = Math.max(
          1,
          Math.floor((thumbnailStrip.clientWidth + gap) / step)
        );

        /*
          Das aktive Vorschaubild rückt auf Position 1, bis das letzte
          Vorschaubild die letzte vollständig sichtbare Position erreicht.
        */
        const maximumStartIndex = Math.max(
          0,
          mediaButtons.length - visibleThumbnailCount
        );
        const targetStartIndex = Math.min(activeButtonIndex, maximumStartIndex);
        const targetLeft = targetStartIndex * step;

        /*
          Der rechts sichtbare Anschnitt benötigt am Ende denselben unsichtbaren
          Freiraum. Padding erzeugt keine zusätzlichen Bilder oder Downloads.
        */
        const lastRect = lastButton.getBoundingClientRect();
        const contentEnd =
          lastRect.right - stripRect.left + thumbnailStrip.scrollLeft;
        const naturalMaximumLeft = Math.max(
          0,
          contentEnd - thumbnailStrip.clientWidth
        );
        const requiredEndSpace = Math.max(
          0,
          Math.ceil(maximumStartIndex * step - naturalMaximumLeft)
        );

        thumbnailStrip.style.paddingRight = `${requiredEndSpace}px`;

        if (Math.abs(targetLeft - thumbnailStrip.scrollLeft) < 0.5) return;

        thumbnailStrip.scrollTo({
          left: targetLeft,
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      };

      const updateMediaButtons = (activeIndex) => {
        const activeId = mediaPanels[activeIndex]?.dataset.mediaId;
        let activeButton = null;

        mediaButtons.forEach((button) => {
          const active = String(button.dataset.mediaTarget) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');

          if (active) {
            activeButton = button;
          }
        });

        scrollThumbnailStrip(activeButton);
      };

      const resetPanelStyles = (panel) => {
        if (!panel) return;
        panel.classList.remove('is-media-animating');
        panel.style.transform = '';
      };

      const setActiveMedia = (targetIndex) => {
        if (targetIndex < 0 || !mediaPanels[targetIndex]) return;

        mediaPanels.forEach((panel, index) => {
          const active = index === targetIndex;

          resetPanelStyles(panel);
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            pausePanelVideos(panel);
          }
        });

        activeMediaIndex = targetIndex;
        updateMediaButtons(targetIndex);
        activatePanelMedia(mediaPanels[targetIndex]);
      };

      const finishMediaAnimation = (panel, callback) => {
        let completed = false;

        const finish = () => {
          if (completed) return;
          completed = true;
          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.propertyName === 'transform') {
            finish();
          }
        };

        panel.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 460);
      };

      const animateMediaTo = (targetIndex, direction) => {
        if (
          isMediaAnimating ||
          targetIndex < 0 ||
          targetIndex === activeMediaIndex ||
          !mediaPanels[targetIndex]
        ) {
          return;
        }

        if (!mobileMediaQuery.matches || reducedMotionQuery.matches) {
          setActiveMedia(targetIndex);
          return;
        }

        const currentPanel = mediaPanels[activeMediaIndex];
        const targetPanel = mediaPanels[targetIndex];
        const slideDirection = direction >= 0 ? 1 : -1;

        primePanelImage(targetPanel);
        isMediaAnimating = true;
        targetPanel.hidden = false;
        targetPanel.setAttribute('aria-hidden', 'false');
        currentPanel.classList.add('is-media-animating');
        targetPanel.classList.add('is-media-animating');

        currentPanel.style.transform = 'translate3d(0, 0, 0)';
        targetPanel.style.transform = `translate3d(${slideDirection * 100}%, 0, 0)`;

        targetPanel.getBoundingClientRect();

        requestAnimationFrame(() => {
          currentPanel.style.transform = `translate3d(${-slideDirection * 100}%, 0, 0)`;
          targetPanel.style.transform = 'translate3d(0, 0, 0)';
        });

        finishMediaAnimation(targetPanel, () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active');
          currentPanel.setAttribute('aria-hidden', 'true');
          pausePanelVideos(currentPanel);

          resetPanelStyles(currentPanel);
          resetPanelStyles(targetPanel);
          targetPanel.hidden = false;
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          activeMediaIndex = targetIndex;
          updateMediaButtons(targetIndex);
          activatePanelMedia(targetPanel);
          isMediaAnimating = false;
        });
      };

      const showMedia = (mediaId, options = {}) => {
        if (!mediaId) return;

        const targetIndex = mediaPanels.findIndex(
          (panel) => String(panel.dataset.mediaId) === String(mediaId)
        );

        if (targetIndex < 0 || targetIndex === activeMediaIndex) return;

        if (options.animate === true) {
          const direction = targetIndex > activeMediaIndex ? 1 : -1;
          animateMediaTo(targetIndex, direction);
        } else {
          setActiveMedia(targetIndex);
        }
      };

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMedia(button.dataset.mediaTarget, { animate: true });
        });
      });

      if (mainMedia && mediaPanels.length > 1) {
        mainMedia.addEventListener('dragstart', (event) => event.preventDefault());

        mainMedia.addEventListener(
          'touchstart',
          (event) => {
            if (
              !mobileMediaQuery.matches ||
              isMediaAnimating ||
              event.touches.length !== 1
            ) {
              return;
            }

            const touch = event.touches[0];

            swipeState = {
              startX: touch.clientX,
              startY: touch.clientY,
              currentX: touch.clientX,
              startTime: performance.now(),
              horizontal: null,
              direction: 0,
              targetIndex: -1,
              targetPanel: null,
            };
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeState || event.touches.length !== 1 || isMediaAnimating) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - swipeState.startX;
            const deltaY = touch.clientY - swipeState.startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            swipeState.currentX = touch.clientX;

            if (swipeState.horizontal === null) {
              if (Math.max(absoluteX, absoluteY) < 7) return;

              swipeState.horizontal = absoluteX > absoluteY;

              if (!swipeState.horizontal) {
                swipeState = null;
                return;
              }

              mainMedia.classList.add('is-swiping');
            }

            if (!swipeState.horizontal) return;

            event.preventDefault();

            const direction = deltaX < 0 ? 1 : -1;
            const targetIndex = wrappedMediaIndex(activeMediaIndex + direction);
            const currentPanel = mediaPanels[activeMediaIndex];

            if (
              direction !== swipeState.direction ||
              targetIndex !== swipeState.targetIndex
            ) {
              if (swipeState.targetPanel) {
                pausePanelVideos(swipeState.targetPanel);
                resetPanelStyles(swipeState.targetPanel);
                swipeState.targetPanel.hidden = true;
                swipeState.targetPanel.setAttribute('aria-hidden', 'true');
              }

              swipeState.direction = direction;
              swipeState.targetIndex = targetIndex;
              swipeState.targetPanel = mediaPanels[targetIndex];
              primePanelImage(swipeState.targetPanel);
              swipeState.targetPanel.hidden = false;
              swipeState.targetPanel.setAttribute('aria-hidden', 'false');
            }

            const width = mainMedia.clientWidth || 1;
            currentPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
            swipeState.targetPanel.style.transform =
              `translate3d(${direction * width + deltaX}px, 0, 0)`;
          },
          { passive: false }
        );

        const finishSwipe = (cancelled = false) => {
          if (!swipeState) return;

          const state = swipeState;
          swipeState = null;
          mainMedia.classList.remove('is-swiping');

          if (!state.horizontal || !state.targetPanel) {
            return;
          }

          const currentPanel = mediaPanels[activeMediaIndex];
          const targetPanel = state.targetPanel;
          const width = mainMedia.clientWidth || 1;
          const deltaX = state.currentX - state.startX;
          const elapsed = Math.max(performance.now() - state.startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed;
          const shouldChange =
            !cancelled &&
            (Math.abs(deltaX) >= Math.min(58, width * 0.18) || velocity > 0.45);

          isMediaAnimating = true;
          currentPanel.classList.add('is-media-animating');
          targetPanel.classList.add('is-media-animating');

          requestAnimationFrame(() => {
            if (shouldChange) {
              currentPanel.style.transform =
                `translate3d(${-state.direction * width}px, 0, 0)`;
              targetPanel.style.transform = 'translate3d(0, 0, 0)';
            } else {
              currentPanel.style.transform = 'translate3d(0, 0, 0)';
              targetPanel.style.transform =
                `translate3d(${state.direction * width}px, 0, 0)`;
            }
          });

          finishMediaAnimation(shouldChange ? targetPanel : currentPanel, () => {
            resetPanelStyles(currentPanel);
            resetPanelStyles(targetPanel);

            if (shouldChange) {
              currentPanel.hidden = true;
              currentPanel.classList.remove('is-active');
              currentPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(currentPanel);

              targetPanel.hidden = false;
              targetPanel.classList.add('is-active');
              targetPanel.setAttribute('aria-hidden', 'false');

              activeMediaIndex = state.targetIndex;
              updateMediaButtons(activeMediaIndex);
              activatePanelMedia(targetPanel);
            } else {
              currentPanel.hidden = false;
              currentPanel.classList.add('is-active');
              currentPanel.setAttribute('aria-hidden', 'false');

              targetPanel.hidden = true;
              targetPanel.classList.remove('is-active');
              targetPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(targetPanel);
            }

            isMediaAnimating = false;
          });
        };

        mainMedia.addEventListener('touchend', () => finishSwipe(false), {
          passive: true,
        });

        mainMedia.addEventListener('touchcancel', () => finishSwipe(true), {
          passive: true,
        });
      }

      if (mainMedia) {
        if ('IntersectionObserver' in window) {
          const galleryVisibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.06 &&
                  document.visibilityState !== 'hidden';

                mainMedia.dataset.fb1Visible = visible ? 'true' : 'false';

                if (visible) {
                  activatePanelMedia(mediaPanels[activeMediaIndex]);
                } else {
                  mediaPanels.forEach((panel) => pausePanelVideos(panel));
                }
              });
            },
            {
              threshold: [0, 0.06, 0.2],
              rootMargin: '30px 0px',
            }
          );

          galleryVisibilityObserver.observe(mainMedia);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              mainMedia.dataset.fb1Visible = 'false';
              mediaPanels.forEach((panel) => pausePanelVideos(panel));
              return;
            }

            const rect = mainMedia.getBoundingClientRect();
            const visible =
              rect.bottom > 0 &&
              rect.top < window.innerHeight &&
              rect.right > 0 &&
              rect.left < window.innerWidth;

            mainMedia.dataset.fb1Visible = visible ? 'true' : 'false';

            if (visible) {
              activatePanelMedia(mediaPanels[activeMediaIndex]);
            }
          });
        } else {
          mainMedia.dataset.fb1Visible = 'true';
        }
      }

      if (mediaPanels.length > 0) {
        setActiveMedia(activeMediaIndex);
      }

      const autoplayVideos = Array.from(
        root.querySelectorAll('[data-fb1-autoplay-video]')
      );
      const videoTriptych = root.querySelector('.fb1-video-triptych');
      let activeAutoplayVideoIndex = 0;
      let autoplayVideosAreVisible = false;
      let autoplayStartTimeout = null;

      const prepareAutoplayVideo = (video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = false;
        video.removeAttribute('loop');
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
      };

      const resetAutoplayVideo = (video) => {
        prepareAutoplayVideo(video);
        video.pause();
        video.preload = 'none';

        if (video.readyState > 0) {
          try {
            video.currentTime = 0;
          } catch (error) {
            /* Das Poster beziehungsweise erste Standbild bleibt sichtbar. */
          }
        }
      };

      const stopAutoplaySequence = () => {
        window.clearTimeout(autoplayStartTimeout);
        autoplayStartTimeout = null;
        autoplayVideos.forEach(resetAutoplayVideo);
      };

      const playAutoplayVideo = (index) => {
        if (
          !autoplayVideosAreVisible ||
          document.visibilityState === 'hidden' ||
          autoplayVideos.length === 0
        ) {
          return;
        }

        activeAutoplayVideoIndex = index % autoplayVideos.length;

        autoplayVideos.forEach((video, videoIndex) => {
          if (videoIndex !== activeAutoplayVideoIndex) {
            resetAutoplayVideo(video);
          }
        });

        const activeVideo = autoplayVideos[activeAutoplayVideoIndex];
        prepareAutoplayVideo(activeVideo);
        activeVideo.preload = 'metadata';

        if (activeVideo.readyState > 0) {
          try {
            activeVideo.currentTime = 0;
          } catch (error) {
            /* Das Video startet beim Abspielen automatisch am Anfang. */
          }
        }

        const playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      const startAutoplaySequence = () => {
        stopAutoplaySequence();
        activeAutoplayVideoIndex = 0;
        autoplayStartTimeout = window.setTimeout(() => {
          autoplayStartTimeout = null;
          playAutoplayVideo(activeAutoplayVideoIndex);
        }, 500);
      };

      autoplayVideos.forEach((video) => {
        resetAutoplayVideo(video);

        video.addEventListener('ended', () => {
          if (video !== autoplayVideos[activeAutoplayVideoIndex]) return;

          resetAutoplayVideo(video);
          playAutoplayVideo(activeAutoplayVideoIndex + 1);
        });
      });

      if (autoplayVideos.length > 0 && videoTriptych) {
        if ('IntersectionObserver' in window) {
          const autoplaySequenceObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const isVisible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.12 &&
                  document.visibilityState !== 'hidden';

                if (isVisible === autoplayVideosAreVisible) return;

                autoplayVideosAreVisible = isVisible;

                if (autoplayVideosAreVisible) {
                  startAutoplaySequence();
                } else {
                  stopAutoplaySequence();
                }
              });
            },
            {
              threshold: [0, 0.12, 0.35],
              rootMargin: '80px 0px',
            }
          );

          autoplaySequenceObserver.observe(videoTriptych);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              autoplayVideosAreVisible = false;
              stopAutoplaySequence();
              return;
            }

            const rect = videoTriptych.getBoundingClientRect();
            autoplayVideosAreVisible =
              rect.bottom > 0 &&
              rect.top < window.innerHeight &&
              rect.right > 0 &&
              rect.left < window.innerWidth;

            if (autoplayVideosAreVisible) {
              startAutoplaySequence();
            }
          });
        } else {
          autoplayVideosAreVisible = true;
          startAutoplaySequence();
        }
      }

      const faq = root.querySelector('.fb1-faq');

      if (faq) {
        const faqItems = Array.from(faq.querySelectorAll('.fb1-faq-item'));
        const closingStates = new WeakMap();
        const faqTransitionDuration = 380;

        const cancelScheduledClose = (item) => {
          const state = closingStates.get(item);
          if (!state) return;

          state.panel.removeEventListener('transitionend', state.onTransitionEnd);
          window.clearTimeout(state.timeoutId);
          closingStates.delete(item);
        };

        const finalizeFaqClose = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-open', 'is-closing');
          item.removeAttribute('open');
        };

        const openFaqItem = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-closing');

          if (!item.open) {
            item.setAttribute('open', '');
          }

          if (reducedMotionQuery.matches) {
            item.classList.add('is-open');
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.add('is-open');
            });
          });
        };

        const closeFaqItem = (item) => {
          if (!item.open) return;

          cancelScheduledClose(item);
          item.classList.add('is-closing');
          item.classList.remove('is-open');

          if (reducedMotionQuery.matches) {
            finalizeFaqClose(item);
            return;
          }

          const panel = item.querySelector('.fb1-faq-panel');
          if (!panel) {
            finalizeFaqClose(item);
            return;
          }

          const onTransitionEnd = (event) => {
            if (
              event.target === panel &&
              event.propertyName === 'grid-template-rows'
            ) {
              finalizeFaqClose(item);
            }
          };

          panel.addEventListener('transitionend', onTransitionEnd);

          const timeoutId = window.setTimeout(
            () => finalizeFaqClose(item),
            faqTransitionDuration
          );

          closingStates.set(item, {
            panel,
            onTransitionEnd,
            timeoutId,
          });
        };

        faqItems.forEach((item) => {
          if (item.open) {
            item.classList.add('is-open');
          }
        });

        faq.addEventListener('click', (event) => {
          const summary = event.target.closest('.fb1-faq-item > summary');
          if (!summary || !faq.contains(summary)) return;

          event.preventDefault();

          const selectedItem = summary.parentElement;
          const selectedIsOpen =
            selectedItem.open &&
            selectedItem.classList.contains('is-open') &&
            !selectedItem.classList.contains('is-closing');

          faqItems.forEach((item) => {
            if (item !== selectedItem && item.open) {
              closeFaqItem(item);
            }
          });

          if (selectedIsOpen) {
            closeFaqItem(selectedItem);
          } else {
            openFaqItem(selectedItem);
          }
        });
      }

      const variantsScript = root.querySelector('[data-flex-variants]');
      const form = root.querySelector('.fb1-product-form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.warn('Flex Buybox1: Variantendaten konnten nicht gelesen werden.', error);
        return;
      }

      const idInput = form.querySelector('[data-variant-id]');
      const optionSelects = form.querySelectorAll('[data-option-position]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addButtonText = form.querySelector('[data-add-button-text]');
      const directCheckoutButton = form.querySelector('[data-direct-checkout]');
      const directCheckoutText = form.querySelector('[data-direct-checkout-text]');
      const directCheckoutStatus = form.querySelector('[data-direct-checkout-status]');
      const priceElement = root.querySelector('[data-product-price]');
      const comparePriceElement = root.querySelector('[data-compare-price]');
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || 'de-DE';
      const updateUrl = root.dataset.updateVariantUrl === 'true';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      let internalVariantUpdate = false;

      const updateVariant = (variant, { syncInput = true } = {}) => {
        if (!variant || !idInput) return;

        if (syncInput) {
          internalVariantUpdate = true;
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          internalVariantUpdate = false;
        }

        if (priceElement) priceElement.textContent = formatMoney(variant.price);

        if (comparePriceElement) {
          const showCompare = Number(variant.compare_at_price) > Number(variant.price);
          comparePriceElement.classList.toggle('is-hidden', !showCompare);
          comparePriceElement.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        }

        if (addButton && addButtonText) {
          addButton.disabled = !variant.available;
          addButtonText.textContent = variant.available
            ? addButton.dataset.availableText
            : addButton.dataset.soldoutText;
        }

        if (directCheckoutButton) {
          directCheckoutButton.disabled = !variant.available;
        }

        const featuredMediaId =
          variant.featured_media && (variant.featured_media.id || variant.featured_media);
        if (featuredMediaId) showMedia(featuredMediaId);

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant },
          })
        );
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(optionSelects)
            .sort(
              (a, b) =>
                Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
            )
            .map((input) => input.value);

          const matchedVariant = variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          updateVariant(matchedVariant);
        });
      });

      if (idInput) {
        idInput.addEventListener('change', () => {
          if (internalVariantUpdate) return;
          const matchedVariant = variants.find(
            (variant) => String(variant.id) === String(idInput.value)
          );
          if (matchedVariant) updateVariant(matchedVariant, { syncInput: false });
        });
      }

      /*
        Eigener Direkt-zur-Kasse-Button.

        Der Button löst bewusst denselben vorhandenen Warenkorb-Button aus,
        damit Kaching weiterhin die aktuell ausgewählte Bundle-, Seiten- und
        Größenkombination verarbeitet. Sobald Shopify die Änderung im Warenkorb
        bestätigt, wird unmittelbar zum Checkout weitergeleitet.
      */
      if (directCheckoutButton && addButton) {
        let directCheckoutRunning = false;
        let checkoutTransitionOverlay = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const ensureCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay && document.body.contains(checkoutTransitionOverlay)) {
            return checkoutTransitionOverlay;
          }

          checkoutTransitionOverlay = document.createElement('div');
          checkoutTransitionOverlay.className = 'fb1-checkout-transition-overlay';
          checkoutTransitionOverlay.setAttribute('role', 'status');
          checkoutTransitionOverlay.setAttribute('aria-live', 'polite');
          checkoutTransitionOverlay.setAttribute('aria-label', 'Weiterleitung zum Checkout');
          checkoutTransitionOverlay.innerHTML = `
            <div class="fb1-checkout-transition-card">
              <span class="fb1-checkout-transition-spinner" aria-hidden="true"></span>
              <p class="fb1-checkout-transition-title">Weiterleitung zum sicheren Checkout …</p>
              <p class="fb1-checkout-transition-copy">Ihre ausgewählte Größe und Seite werden übernommen.</p>
            </div>
          `;

          document.body.appendChild(checkoutTransitionOverlay);
          return checkoutTransitionOverlay;
        };

        const showCheckoutTransitionOverlay = () => {
          const overlay = ensureCheckoutTransitionOverlay();

          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';

          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';

          overlay.classList.add('is-visible');
        };

        const hideCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay) {
            checkoutTransitionOverlay.classList.remove('is-visible');
          }

          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
        };

        const waitForVisiblePaint = () =>
          new Promise((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve);
            });
          });

        const setDirectCheckoutState = (loading, message = '') => {
          directCheckoutRunning = loading;
          directCheckoutButton.classList.toggle('is-loading', loading);
          directCheckoutButton.setAttribute('aria-busy', loading ? 'true' : 'false');

          /*
            Der normale Add-to-Cart-Ablauf bleibt für Kaching erhalten.
            Nur die sichtbare Warenkorb-Oberfläche wird bis zur Weiterleitung
            in den Checkout temporär unterdrückt.
          */
          document.documentElement.classList.toggle('fb1-direct-checkout-active', loading);
          if (document.body) {
            document.body.classList.toggle('fb1-direct-checkout-active', loading);
          }

          if (directCheckoutText) {
            directCheckoutText.textContent = loading
              ? directCheckoutButton.dataset.loadingText
              : directCheckoutButton.dataset.defaultText;
          }

          if (directCheckoutStatus) {
            directCheckoutStatus.textContent = message;
          }

          if (loading) {
            directCheckoutButton.disabled = true;
          } else {
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(idInput?.value)
            );
            directCheckoutButton.disabled = selectedVariant
              ? !selectedVariant.available
              : addButton.disabled;
          }
        };

        const getCartSnapshot = async () => {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
          });

          if (!response.ok) {
            throw new Error('Warenkorb konnte nicht gelesen werden.');
          }

          const cart = await response.json();

          return JSON.stringify({
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            items: (cart.items || []).map((item) => ({
              key: item.key,
              quantity: item.quantity,
              finalLinePrice: item.final_line_price,
              properties: item.properties || null,
            })),
          });
        };

        const waitForCartChange = async (beforeSnapshot, timeout = 10000) => {
          const startedAt = Date.now();

          while (Date.now() - startedAt < timeout) {
            await new Promise((resolve) => window.setTimeout(resolve, 180));

            try {
              const currentSnapshot = await getCartSnapshot();
              if (currentSnapshot !== beforeSnapshot) {
                return true;
              }
            } catch (error) {
              /* Kurze Netzwerkfehler werden bis zum Timeout erneut geprüft. */
            }
          }

          return false;
        };

        directCheckoutButton.addEventListener('click', async () => {
          if (directCheckoutRunning || addButton.disabled) return;

          setDirectCheckoutState(true, 'Ihre Auswahl wird für den Checkout vorbereitet …');
          showCheckoutTransitionOverlay();

          try {
            /*
              Zwei Render-Zyklen abwarten: Die weiße Übergangsebene ist damit
              garantiert sichtbar, bevor Kaching im Hintergrund den
              Warenkorb aktualisiert oder das Theme einen Drawer öffnet.
            */
            await waitForVisiblePaint();

            const beforeSnapshot = await getCartSnapshot();

            /*
              Der vorhandene Button bleibt die einzige Add-to-Cart-Logik.
              Dadurch bleiben Kaching-Auswahl und Bundle-Rabatt erhalten.
              Ein eventuell geöffneter Warenkorb liegt vollständig hinter der
              Übergangsebene und ist für den Kunden nicht sichtbar.
            */
            addButton.click();

            const cartChanged = await waitForCartChange(beforeSnapshot);

            if (!cartChanged) {
              throw new Error('Die Auswahl wurde nicht in den Warenkorb übernommen.');
            }

            window.location.assign('/checkout');
          } catch (error) {
            console.warn('Flex Buybox1: Direkter Checkout fehlgeschlagen.', error);
            hideCheckoutTransitionOverlay();
            setDirectCheckoutState(
              false,
              'Bitte prüfen Sie Größe, Seite und Bundle-Auswahl und versuchen Sie es erneut.'
            );
          }
        });

        window.addEventListener('pageshow', () => {
          hideCheckoutTransitionOverlay();
          setDirectCheckoutState(false, '');
        });
      }
    };

    const queuedRoots = new WeakSet();

    const hydrateRoot = (root) => {
      if (!root || root.dataset.flexBuybox1Initialized === 'true') return;
      initFlexBuybox1(root);
    };

    const scheduleRootHydration = (root) => {
      if (
        !root ||
        root.dataset.flexBuybox1Initialized === 'true' ||
        queuedRoots.has(root)
      ) {
        return;
      }

      queuedRoots.add(root);

      const run = () => {
        queuedRoots.delete(root);
        hydrateRoot(root);
      };

      /*
        Die PDP-Buybox liegt direkt im sichtbaren Bereich. Deshalb bleibt das
        Markup sofort sichtbar; nur die nicht kritische JavaScript-Hydrierung
        wird auf den nächsten Render-Zyklus verschoben, damit Bild, Titel und
        Preis zuerst gezeichnet werden können.
      */
      if (window.Shopify?.designMode || window.location.hash === '#bundle') {
        run();
      } else {
        window.requestAnimationFrame(run);
      }
    };

    const boot = (scope = document) => {
      if (scope.matches && scope.matches('.flex-buybox1')) {
        scheduleRootHydration(scope);
        return;
      }

      scope.querySelectorAll('.flex-buybox1').forEach(scheduleRootHydration);
    };

    const scrollToBundle = () => {
      const target = document.getElementById('bundle');
      if (!target) return;

      const root = target.closest('.flex-buybox1');
      if (root) {
        hydrateRoot(root);
        root.dispatchEvent(new CustomEvent('fb1:hydrate-kaching'));
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      });
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href="#bundle"]');
      if (!link) return;

      event.preventDefault();

      if (window.history?.pushState) {
        window.history.pushState(null, '', '#bundle');
      } else {
        window.location.hash = 'bundle';
      }

      scrollToBundle();
    });

    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          boot();

          if (window.location.hash === '#bundle') {
            scrollToBundle();
          }
        },
        { once: true }
      );
    } else {
      boot();

      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-buybox2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlexBuybox2 = (root) => {
      if (!root || root.dataset.flexBuybox2Initialized === 'true') return;
      root.dataset.flexBuybox2Initialized = 'true';

      /*
        Kaching wird erst nach dem ersten Render-Zyklus erzeugt. Dadurch kann
        der Browser Galerie, Titel und Preis zuerst zeichnen, ohne das Widget
        aus dem sichtbaren Kaufbereich zu entfernen.
      */
      root.querySelectorAll('[data-kaching-deferred]').forEach((container) => {
        const template = container.querySelector('[data-kaching-template]');
        if (!template) return;
        container.appendChild(template.content.cloneNode(true));
        template.remove();
        container.removeAttribute('data-kaching-deferred');
      });

      const mediaButtons = Array.from(root.querySelectorAll('[data-media-target]'));
      const mediaPanels = Array.from(root.querySelectorAll('[data-media-id]'));
      const mainMedia = root.querySelector('.fb2-main-media');
      const galleryImages = Array.from(
        root.querySelectorAll('.fb2-media-panel img')
      );
      const ratingAvatars = Array.from(
        root.querySelectorAll('[data-fb2-rating-avatar]')
      );
      const galleryVideos = Array.from(
        root.querySelectorAll('[data-fb2-gallery-video]')
      );
      const externalGalleryVideos = Array.from(
        root.querySelectorAll('[data-fb2-external-video]')
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      const hydrateDeferredImage = (image, priority = 'low') => {
        if (!image) return;

        image.decoding = 'async';
        image.loading = 'eager';

        if ('fetchPriority' in image) {
          image.fetchPriority = priority;
        }

        if (image.dataset.fb2ImageHydrated !== 'true') {
          const deferredSrcset = image.dataset.srcset;
          const deferredSrc = image.dataset.src;

          if (deferredSrcset) image.srcset = deferredSrcset;
          if (deferredSrc) image.src = deferredSrc;

          image.dataset.fb2ImageHydrated = 'true';
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
        }

        if (typeof image.decode === 'function') {
          image.decode().catch(() => {});
        }
      };

      galleryImages.forEach((image) => {
        const panel = image.closest('.fb2-media-panel');
        const isInitialImage =
          panel?.classList.contains('is-active') && panel.hidden === false;

        image.decoding = 'async';

        if (isInitialImage) {
          hydrateDeferredImage(image, 'high');
        } else {
          image.loading = 'lazy';
          if ('fetchPriority' in image) image.fetchPriority = 'low';
        }
      });

      const hydrateRatingAvatar = (image) => {
        if (!image || image.dataset.fb2RatingAvatarHydrated === 'true') return;

        const deferredSrcset = image.dataset.srcset;
        const deferredSrc = image.dataset.src;

        image.decoding = 'async';
        image.loading = 'lazy';
        if ('fetchPriority' in image) image.fetchPriority = 'low';

        if (deferredSrcset) image.srcset = deferredSrcset;
        if (deferredSrc) image.src = deferredSrc;

        image.dataset.fb2RatingAvatarHydrated = 'true';
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      };

      const scheduleRatingAvatarHydration = () => {
        if (ratingAvatars.length === 0) return;

        const hydrateAll = () => {
          const run = () => {
            ratingAvatars.forEach((image, index) => {
              window.setTimeout(() => hydrateRatingAvatar(image), index * 60);
            });
          };

          window.setTimeout(() => {
            if ('requestIdleCallback' in window) {
              window.requestIdleCallback(run, { timeout: 1200 });
            } else {
              run();
            }
          }, 3000);
        };

        if (document.readyState === 'complete') {
          hydrateAll();
        } else {
          window.addEventListener('load', hydrateAll, { once: true });
        }
      };

      scheduleRatingAvatarHydration();

      const primePanelImage = (panel, priority = 'high') => {
        panel?.querySelectorAll('img').forEach((image) => {
          hydrateDeferredImage(image, priority);
        });
      };

      let activeMediaIndex = mediaPanels.findIndex(
        (panel) => panel.classList.contains('is-active') && !panel.hidden
      );
      let isMediaAnimating = false;
      let swipeState = null;

      if (activeMediaIndex < 0 && mediaPanels.length > 0) {
        activeMediaIndex = 0;
      }

      const wrappedMediaIndex = (index) => {
        if (!mediaPanels.length) return -1;
        return (index + mediaPanels.length) % mediaPanels.length;
      };

      const safelyResetNativeVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /*
            currentTime kann vor dem ersten Laden noch nicht gesetzt werden.
            Das Video bleibt trotzdem pausiert und wird beim Aktivieren auf 0 gesetzt.
          */
        }
      };

      const hydrateNativeGalleryVideo = (video, preload = 'auto') => {
        if (!video) return;

        let sourceChanged = false;

        video.querySelectorAll('source[data-src]').forEach((source) => {
          if (!source.dataset.src) return;
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          sourceChanged = true;
        });

        video.preload = preload;

        if (sourceChanged || video.dataset.fb2SourcesHydrated !== 'true') {
          video.dataset.fb2SourcesHydrated = 'true';
          video.load();
        }
      };

      const sendExternalVideoCommand = (iframe, command, value) => {
        if (!iframe?.contentWindow) return;

        const host = iframe.dataset.fb2VideoHost;

        if (host === 'youtube') {
          const args = typeof value === 'undefined' ? [] : [value];
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: command,
              args,
            }),
            '*'
          );
          return;
        }

        if (host === 'vimeo') {
          const payload = { method: command };
          if (typeof value !== 'undefined') payload.value = value;
          iframe.contentWindow.postMessage(payload, '*');
        }
      };

      const registerExternalVideoEvents = (iframe) => {
        if (!iframe || iframe.dataset.fb2EventsRegistered === 'true') return;
        iframe.dataset.fb2EventsRegistered = 'true';

        if (iframe.dataset.fb2VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'onStateChange');
        } else if (iframe.dataset.fb2VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'ended');
        }
      };

      const loadExternalVideo = (iframe) =>
        new Promise((resolve) => {
          if (!iframe) {
            resolve();
            return;
          }

          if (iframe.dataset.fb2Loaded === 'true') {
            resolve();
            return;
          }

          const source = iframe.dataset.src;
          if (!source) {
            resolve();
            return;
          }

          const finish = () => {
            iframe.dataset.fb2Loaded = 'true';
            registerExternalVideoEvents(iframe);
            resolve();
          };

          iframe.addEventListener('load', finish, { once: true });
          iframe.src = source;
        });

      const preparePanelMedia = (panel, priority = 'low') => {
        if (!panel) return;

        primePanelImage(panel, priority);

        panel.querySelectorAll('[data-fb2-gallery-video]').forEach((video) => {
          hydrateNativeGalleryVideo(video, 'auto');
        });

        panel.querySelectorAll('[data-fb2-external-video]').forEach((iframe) => {
          loadExternalVideo(iframe).catch(() => {});
        });
      };

      const resetExternalVideo = (iframe) => {
        if (!iframe) return;

        iframe.dataset.fb2PlayToken = String(
          (Number(iframe.dataset.fb2PlayToken) || 0) + 1
        );

        if (iframe.dataset.fb2Loaded !== 'true') return;

        if (iframe.dataset.fb2VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'pauseVideo');
          sendExternalVideoCommand(iframe, 'seekTo', 0);
        } else if (iframe.dataset.fb2VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'pause');
          sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
        }
      };

      const playExternalVideo = async (iframe) => {
        if (!iframe) return;

        const playToken = String(
          (Number(iframe.dataset.fb2PlayToken) || 0) + 1
        );
        iframe.dataset.fb2PlayToken = playToken;

        await loadExternalVideo(iframe);

        const panel = iframe.closest('.fb2-media-panel');
        if (
          iframe.dataset.fb2PlayToken !== playToken ||
          !panel?.classList.contains('is-active') ||
          panel.hidden
        ) {
          return;
        }

        iframe.closest('.fb2-external-video-shell')?.classList.add('is-loaded');

        const play = () => {
          if (
            iframe.dataset.fb2PlayToken !== playToken ||
            !panel.classList.contains('is-active') ||
            panel.hidden
          ) {
            return;
          }

          if (iframe.dataset.fb2VideoHost === 'youtube') {
            sendExternalVideoCommand(iframe, 'mute');
            sendExternalVideoCommand(iframe, 'seekTo', 0);
            sendExternalVideoCommand(iframe, 'playVideo');
          } else if (iframe.dataset.fb2VideoHost === 'vimeo') {
            sendExternalVideoCommand(iframe, 'setVolume', 0);
            sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
            sendExternalVideoCommand(iframe, 'play');
          }
        };

        /*
          Einige externe Player benötigen nach dem iframe-load einen kurzen
          Moment, bevor sie API-Befehle annehmen. Die Wiederholung ist stumm
          und unsichtbar, erhöht aber die Zuverlässigkeit deutlich.
        */
        play();
        window.setTimeout(play, 180);
        window.setTimeout(play, 500);
      };

      const playNativeGalleryVideo = (video) => {
        if (!video) return;

        hydrateNativeGalleryVideo(video, 'auto');

        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
        video.preload = 'auto';

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Das Abspielen startet nach dem ersten Laden automatisch bei 0. */
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      galleryVideos.forEach((video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'none';

        video.addEventListener('ended', () => {
          const panel = video.closest('.fb2-media-panel');
          const shouldRestart =
            panel?.classList.contains('is-active') &&
            panel.hidden === false &&
            mainMedia?.dataset.fb2Visible === 'true' &&
            document.visibilityState !== 'hidden';

          if (!shouldRestart) {
            safelyResetNativeVideo(video);
            return;
          }

          try {
            video.currentTime = 0;
          } catch (error) {
            /* Der native Loop übernimmt den Neustart, sobald die Datei bereit ist. */
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      });

      const onExternalVideoMessage = (event) => {
        const iframe = externalGalleryVideos.find(
          (candidate) => candidate.contentWindow === event.source
        );
        if (!iframe) return;

        let payload = event.data;

        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (error) {
            return;
          }
        }

        const youtubeEnded =
          iframe.dataset.fb2VideoHost === 'youtube' &&
          payload?.event === 'onStateChange' &&
          Number(payload.info) === 0;

        const vimeoEnded =
          iframe.dataset.fb2VideoHost === 'vimeo' &&
          payload?.event === 'ended';

        if (youtubeEnded || vimeoEnded) {
          const panel = iframe.closest('.fb2-media-panel');
          const shouldRestart =
            panel?.classList.contains('is-active') &&
            panel.hidden === false &&
            mainMedia?.dataset.fb2Visible === 'true' &&
            document.visibilityState !== 'hidden';

          if (shouldRestart) {
            playExternalVideo(iframe);
          } else {
            resetExternalVideo(iframe);
          }
        }
      };

      if (externalGalleryVideos.length > 0) {
        window.addEventListener('message', onExternalVideoMessage);
      }

      const pausePanelVideos = (panel) => {
        if (!panel) return;

        panel.querySelectorAll('[data-fb2-gallery-video]').forEach((video) => {
          safelyResetNativeVideo(video);
        });

        panel.querySelectorAll('[data-fb2-external-video]').forEach((iframe) => {
          resetExternalVideo(iframe);
        });
      };

      const activatePanelMedia = (panel) => {
        if (!panel) return;

        preparePanelMedia(panel, 'high');

        if (mainMedia && mainMedia.dataset.fb2Visible !== 'true') {
          return;
        }

        panel.querySelectorAll('[data-fb2-gallery-video]').forEach((video) => {
          playNativeGalleryVideo(video);
        });

        panel.querySelectorAll('[data-fb2-external-video]').forEach((iframe) => {
          playExternalVideo(iframe);
        });
      };

      const thumbnailStrip = root.querySelector('.fb2-thumbnails');

      const scrollThumbnailStrip = (activeButton) => {
        if (!thumbnailStrip || !activeButton || mediaButtons.length < 2) return;

        const firstButton = mediaButtons[0];
        const lastButton = mediaButtons[mediaButtons.length - 1];
        const firstRect = firstButton.getBoundingClientRect();
        const stripRect = thumbnailStrip.getBoundingClientRect();
        const stripStyles = window.getComputedStyle(thumbnailStrip);
        const gap = Number.parseFloat(stripStyles.columnGap || stripStyles.gap) || 0;
        const buttonWidth = firstRect.width;
        const step = buttonWidth + gap;

        if (buttonWidth <= 0 || step <= 0 || thumbnailStrip.clientWidth <= 0) return;

        /*
          Nur vollständig sichtbare Vorschaubilder zählen. Das rechts
          angeschnittene Vorschaubild zählt nicht als vollständige Position.
        */
        const visibleThumbnailCount = Math.max(
          1,
          Math.floor((thumbnailStrip.clientWidth + gap) / step)
        );
        const activeButtonIndex = mediaButtons.indexOf(activeButton);

        if (activeButtonIndex < 0) return;

        /*
          Das aktive Vorschaubild rückt auf Position 1, bis das letzte
          Vorschaubild die letzte vollständig sichtbare Position erreicht.
        */
        const maximumStartIndex = Math.max(
          0,
          mediaButtons.length - visibleThumbnailCount
        );
        const targetStartIndex = Math.min(activeButtonIndex, maximumStartIndex);
        const targetLeft = targetStartIndex * step;

        /*
          Der rechts sichtbare Anschnitt benötigt am Ende denselben unsichtbaren
          Freiraum. Padding erzeugt keine zusätzlichen Bilder oder Downloads.
        */
        const lastRect = lastButton.getBoundingClientRect();
        const contentEnd =
          lastRect.right - stripRect.left + thumbnailStrip.scrollLeft;
        const naturalMaximumLeft = Math.max(
          0,
          contentEnd - thumbnailStrip.clientWidth
        );
        const requiredEndSpace = Math.max(
          0,
          Math.ceil(maximumStartIndex * step - naturalMaximumLeft)
        );

        thumbnailStrip.style.paddingRight = `${requiredEndSpace}px`;

        if (Math.abs(targetLeft - thumbnailStrip.scrollLeft) < 0.5) return;

        thumbnailStrip.scrollTo({
          left: targetLeft,
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      };

      const updateMediaButtons = (activeIndex) => {
        const activeId = mediaPanels[activeIndex]?.dataset.mediaId;
        let activeButton = null;

        mediaButtons.forEach((button) => {
          const active = String(button.dataset.mediaTarget) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');

          if (active) activeButton = button;
        });

        scrollThumbnailStrip(activeButton);
      };

      const resetPanelStyles = (panel) => {
        if (!panel) return;
        panel.classList.remove('is-media-animating');
        panel.style.transform = '';
      };

      const setActiveMedia = (targetIndex) => {
        if (targetIndex < 0 || !mediaPanels[targetIndex]) return;

        mediaPanels.forEach((panel, index) => {
          const active = index === targetIndex;

          resetPanelStyles(panel);
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            pausePanelVideos(panel);
          }
        });

        activeMediaIndex = targetIndex;
        updateMediaButtons(targetIndex);
        activatePanelMedia(mediaPanels[targetIndex]);
      };

      const finishMediaAnimation = (panel, callback) => {
        let completed = false;

        const finish = () => {
          if (completed) return;
          completed = true;
          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.propertyName === 'transform') {
            finish();
          }
        };

        panel.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 460);
      };

      const animateMediaTo = (targetIndex, direction) => {
        if (
          isMediaAnimating ||
          targetIndex < 0 ||
          targetIndex === activeMediaIndex ||
          !mediaPanels[targetIndex]
        ) {
          return;
        }

        if (!mobileMediaQuery.matches || reducedMotionQuery.matches) {
          setActiveMedia(targetIndex);
          return;
        }

        const currentPanel = mediaPanels[activeMediaIndex];
        const targetPanel = mediaPanels[targetIndex];
        const slideDirection = direction >= 0 ? 1 : -1;

        preparePanelMedia(targetPanel, 'high');
        isMediaAnimating = true;
        targetPanel.hidden = false;
        targetPanel.setAttribute('aria-hidden', 'false');
        currentPanel.classList.add('is-media-animating');
        targetPanel.classList.add('is-media-animating');

        currentPanel.style.transform = 'translate3d(0, 0, 0)';
        targetPanel.style.transform = `translate3d(${slideDirection * 100}%, 0, 0)`;

        targetPanel.getBoundingClientRect();

        requestAnimationFrame(() => {
          currentPanel.style.transform = `translate3d(${-slideDirection * 100}%, 0, 0)`;
          targetPanel.style.transform = 'translate3d(0, 0, 0)';
        });

        finishMediaAnimation(targetPanel, () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active');
          currentPanel.setAttribute('aria-hidden', 'true');
          pausePanelVideos(currentPanel);

          resetPanelStyles(currentPanel);
          resetPanelStyles(targetPanel);
          targetPanel.hidden = false;
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          activeMediaIndex = targetIndex;
          updateMediaButtons(targetIndex);
          activatePanelMedia(targetPanel);
          isMediaAnimating = false;
        });
      };

      const showMedia = (mediaId, options = {}) => {
        if (!mediaId) return;

        const targetIndex = mediaPanels.findIndex(
          (panel) => String(panel.dataset.mediaId) === String(mediaId)
        );

        if (targetIndex < 0 || targetIndex === activeMediaIndex) return;

        preparePanelMedia(mediaPanels[targetIndex], 'high');

        if (options.animate === true) {
          const direction = targetIndex > activeMediaIndex ? 1 : -1;
          animateMediaTo(targetIndex, direction);
        } else {
          setActiveMedia(targetIndex);
        }
      };

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMedia(button.dataset.mediaTarget, { animate: true });
        });
      });

      if (mainMedia && mediaPanels.length > 1) {
        mainMedia.addEventListener('dragstart', (event) => event.preventDefault());

        mainMedia.addEventListener(
          'touchstart',
          (event) => {
            if (
              !mobileMediaQuery.matches ||
              isMediaAnimating ||
              event.touches.length !== 1
            ) {
              return;
            }

            const touch = event.touches[0];

            swipeState = {
              startX: touch.clientX,
              startY: touch.clientY,
              currentX: touch.clientX,
              startTime: performance.now(),
              horizontal: null,
              direction: 0,
              targetIndex: -1,
              targetPanel: null,
            };
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeState || event.touches.length !== 1 || isMediaAnimating) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - swipeState.startX;
            const deltaY = touch.clientY - swipeState.startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            swipeState.currentX = touch.clientX;

            if (swipeState.horizontal === null) {
              if (Math.max(absoluteX, absoluteY) < 7) return;

              swipeState.horizontal = absoluteX > absoluteY;

              if (!swipeState.horizontal) {
                swipeState = null;
                return;
              }

              mainMedia.classList.add('is-swiping');
            }

            if (!swipeState.horizontal) return;

            event.preventDefault();

            const direction = deltaX < 0 ? 1 : -1;
            const targetIndex = wrappedMediaIndex(activeMediaIndex + direction);
            const currentPanel = mediaPanels[activeMediaIndex];

            if (
              direction !== swipeState.direction ||
              targetIndex !== swipeState.targetIndex
            ) {
              if (swipeState.targetPanel) {
                pausePanelVideos(swipeState.targetPanel);
                resetPanelStyles(swipeState.targetPanel);
                swipeState.targetPanel.hidden = true;
                swipeState.targetPanel.setAttribute('aria-hidden', 'true');
              }

              swipeState.direction = direction;
              swipeState.targetIndex = targetIndex;
              swipeState.targetPanel = mediaPanels[targetIndex];
              preparePanelMedia(swipeState.targetPanel, 'high');
              swipeState.targetPanel.hidden = false;
              swipeState.targetPanel.setAttribute('aria-hidden', 'false');
            }

            const width = mainMedia.clientWidth || 1;
            currentPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
            swipeState.targetPanel.style.transform =
              `translate3d(${direction * width + deltaX}px, 0, 0)`;
          },
          { passive: false }
        );

        const finishSwipe = (cancelled = false) => {
          if (!swipeState) return;

          const state = swipeState;
          swipeState = null;
          mainMedia.classList.remove('is-swiping');

          if (!state.horizontal || !state.targetPanel) {
            return;
          }

          const currentPanel = mediaPanels[activeMediaIndex];
          const targetPanel = state.targetPanel;
          const width = mainMedia.clientWidth || 1;
          const deltaX = state.currentX - state.startX;
          const elapsed = Math.max(performance.now() - state.startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed;
          const shouldChange =
            !cancelled &&
            (Math.abs(deltaX) >= Math.min(58, width * 0.18) || velocity > 0.45);

          isMediaAnimating = true;
          currentPanel.classList.add('is-media-animating');
          targetPanel.classList.add('is-media-animating');

          requestAnimationFrame(() => {
            if (shouldChange) {
              currentPanel.style.transform =
                `translate3d(${-state.direction * width}px, 0, 0)`;
              targetPanel.style.transform = 'translate3d(0, 0, 0)';
            } else {
              currentPanel.style.transform = 'translate3d(0, 0, 0)';
              targetPanel.style.transform =
                `translate3d(${state.direction * width}px, 0, 0)`;
            }
          });

          finishMediaAnimation(shouldChange ? targetPanel : currentPanel, () => {
            resetPanelStyles(currentPanel);
            resetPanelStyles(targetPanel);

            if (shouldChange) {
              currentPanel.hidden = true;
              currentPanel.classList.remove('is-active');
              currentPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(currentPanel);

              targetPanel.hidden = false;
              targetPanel.classList.add('is-active');
              targetPanel.setAttribute('aria-hidden', 'false');

              activeMediaIndex = state.targetIndex;
              updateMediaButtons(activeMediaIndex);
              activatePanelMedia(targetPanel);
            } else {
              currentPanel.hidden = false;
              currentPanel.classList.add('is-active');
              currentPanel.setAttribute('aria-hidden', 'false');

              targetPanel.hidden = true;
              targetPanel.classList.remove('is-active');
              targetPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(targetPanel);
            }

            isMediaAnimating = false;
          });
        };

        mainMedia.addEventListener('touchend', () => finishSwipe(false), {
          passive: true,
        });

        mainMedia.addEventListener('touchcancel', () => finishSwipe(true), {
          passive: true,
        });
      }

      if (mainMedia) {
        if ('IntersectionObserver' in window) {
          const galleryVisibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.06 &&
                  document.visibilityState !== 'hidden';

                mainMedia.dataset.fb2Visible = visible ? 'true' : 'false';

                if (visible) {
                  activatePanelMedia(mediaPanels[activeMediaIndex]);
                } else {
                  mediaPanels.forEach((panel) => pausePanelVideos(panel));
                }
              });
            },
            {
              threshold: [0, 0.06, 0.2],
              rootMargin: '30px 0px',
            }
          );

          galleryVisibilityObserver.observe(mainMedia);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              mainMedia.dataset.fb2Visible = 'false';
              mediaPanels.forEach((panel) => pausePanelVideos(panel));
              return;
            }

            const rect = mainMedia.getBoundingClientRect();
            const visible =
              rect.bottom > 0 &&
              rect.top < window.innerHeight &&
              rect.right > 0 &&
              rect.left < window.innerWidth;

            mainMedia.dataset.fb2Visible = visible ? 'true' : 'false';

            if (visible) {
              activatePanelMedia(mediaPanels[activeMediaIndex]);
            }
          });
        } else {
          mainMedia.dataset.fb2Visible = 'true';
        }
      }

      if (mediaPanels.length > 0) {
        setActiveMedia(activeMediaIndex);
      }

      const scheduleDeferredGalleryPreload = () => {
        if (mediaPanels.length <= 1) return;

        const preloadOrder = [];
        const queuedPanels = new Set();
        const queuePanel = (index) => {
          const normalizedIndex = wrappedMediaIndex(index);
          const panel = mediaPanels[normalizedIndex];

          if (!panel || normalizedIndex === activeMediaIndex || queuedPanels.has(panel)) {
            return;
          }

          queuedPanels.add(panel);
          preloadOrder.push(panel);
        };

        /* Das direkt nächste Medium wird zuerst vorbereitet. */
        queuePanel(activeMediaIndex + 1);
        queuePanel(activeMediaIndex - 1);
        mediaPanels.forEach((panel, index) => queuePanel(index));

        window.setTimeout(() => {
          preloadOrder.forEach((panel, index) => {
            window.setTimeout(() => {
              if (!root.isConnected) return;
              preparePanelMedia(panel, 'low');
            }, index * 160);
          });
        }, 3000);
      };

      scheduleDeferredGalleryPreload();

      const autoplayVideos = Array.from(
        root.querySelectorAll('[data-fb2-autoplay-video]')
      );

      const setLoopingVideoState = (video, shouldPlay) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');

        if (!shouldPlay) {
          video.pause();
          return;
        }

        video.preload = 'metadata';
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      autoplayVideos.forEach((video) => {
        setLoopingVideoState(video, false);
      });

      if (autoplayVideos.length > 0) {
        if ('IntersectionObserver' in window) {
          const loopingVideoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const shouldPlay =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.12 &&
                  document.visibilityState !== 'hidden';

                setLoopingVideoState(entry.target, shouldPlay);
              });
            },
            {
              threshold: [0, 0.12, 0.35],
              rootMargin: '80px 0px',
            }
          );

          autoplayVideos.forEach((video) => loopingVideoObserver.observe(video));

          document.addEventListener('visibilitychange', () => {
            autoplayVideos.forEach((video) => {
              if (document.visibilityState === 'hidden') {
                setLoopingVideoState(video, false);
                return;
              }

              const rect = video.getBoundingClientRect();
              const visible =
                rect.bottom > 0 &&
                rect.top < window.innerHeight &&
                rect.right > 0 &&
                rect.left < window.innerWidth;

              setLoopingVideoState(video, visible);
            });
          });
        } else {
          autoplayVideos.forEach((video) => setLoopingVideoState(video, true));
        }
      }

      const faq = root.querySelector('.fb2-faq');

      if (faq) {
        const faqItems = Array.from(faq.querySelectorAll('.fb2-faq-item'));
        const closingStates = new WeakMap();
        const faqTransitionDuration = 380;

        const cancelScheduledClose = (item) => {
          const state = closingStates.get(item);
          if (!state) return;

          state.panel.removeEventListener('transitionend', state.onTransitionEnd);
          window.clearTimeout(state.timeoutId);
          closingStates.delete(item);
        };

        const finalizeFaqClose = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-open', 'is-closing');
          item.removeAttribute('open');
        };

        const openFaqItem = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-closing');

          if (!item.open) {
            item.setAttribute('open', '');
          }

          if (reducedMotionQuery.matches) {
            item.classList.add('is-open');
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.add('is-open');
            });
          });
        };

        const closeFaqItem = (item) => {
          if (!item.open) return;

          cancelScheduledClose(item);
          item.classList.add('is-closing');
          item.classList.remove('is-open');

          if (reducedMotionQuery.matches) {
            finalizeFaqClose(item);
            return;
          }

          const panel = item.querySelector('.fb2-faq-panel');
          if (!panel) {
            finalizeFaqClose(item);
            return;
          }

          const onTransitionEnd = (event) => {
            if (
              event.target === panel &&
              event.propertyName === 'grid-template-rows'
            ) {
              finalizeFaqClose(item);
            }
          };

          panel.addEventListener('transitionend', onTransitionEnd);

          const timeoutId = window.setTimeout(
            () => finalizeFaqClose(item),
            faqTransitionDuration
          );

          closingStates.set(item, {
            panel,
            onTransitionEnd,
            timeoutId,
          });
        };

        faqItems.forEach((item) => {
          if (item.open) {
            item.classList.add('is-open');
          }
        });

        faq.addEventListener('click', (event) => {
          const summary = event.target.closest('.fb2-faq-item > summary');
          if (!summary || !faq.contains(summary)) return;

          event.preventDefault();

          const selectedItem = summary.parentElement;
          const selectedIsOpen =
            selectedItem.open &&
            selectedItem.classList.contains('is-open') &&
            !selectedItem.classList.contains('is-closing');

          faqItems.forEach((item) => {
            if (item !== selectedItem && item.open) {
              closeFaqItem(item);
            }
          });

          if (selectedIsOpen) {
            closeFaqItem(selectedItem);
          } else {
            openFaqItem(selectedItem);
          }
        });
      }

      const variantsScript = root.querySelector('[data-flex-variants]');
      const form = root.querySelector('.fb2-product-form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.warn('Flex Buybox2: Variantendaten konnten nicht gelesen werden.', error);
        return;
      }

      const idInput = form.querySelector('[data-variant-id]');
      const optionSelects = form.querySelectorAll('[data-option-position]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addButtonText = form.querySelector('[data-add-button-text]');
      const directCheckoutButton = form.querySelector('[data-direct-checkout]');
      const directCheckoutText = form.querySelector('[data-direct-checkout-text]');
      const directCheckoutStatus = form.querySelector('[data-direct-checkout-status]');
      const priceElement = root.querySelector('[data-product-price]');
      const comparePriceElement = root.querySelector('[data-compare-price]');
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || 'de-DE';
      const updateUrl = root.dataset.updateVariantUrl === 'true';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      let internalVariantUpdate = false;

      const updateVariant = (variant, { syncInput = true } = {}) => {
        if (!variant || !idInput) return;

        if (syncInput) {
          internalVariantUpdate = true;
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          internalVariantUpdate = false;
        }

        if (priceElement) priceElement.textContent = formatMoney(variant.price);

        if (comparePriceElement) {
          const showCompare = Number(variant.compare_at_price) > Number(variant.price);
          comparePriceElement.classList.toggle('is-hidden', !showCompare);
          comparePriceElement.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        }

        if (addButton && addButtonText) {
          addButton.disabled = !variant.available;
          addButtonText.textContent = variant.available
            ? addButton.dataset.availableText
            : addButton.dataset.soldoutText;
        }

        if (directCheckoutButton) {
          directCheckoutButton.disabled = !variant.available;
        }

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant },
          })
        );
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(optionSelects)
            .sort(
              (a, b) =>
                Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
            )
            .map((input) => input.value);

          const matchedVariant = variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          updateVariant(matchedVariant);
        });
      });

      if (idInput) {
        idInput.addEventListener('change', () => {
          if (internalVariantUpdate) return;
          const matchedVariant = variants.find(
            (variant) => String(variant.id) === String(idInput.value)
          );
          if (matchedVariant) updateVariant(matchedVariant, { syncInput: false });
        });
      }

      /*
        Eigener Direkt-zur-Kasse-Button.

        Der Button löst bewusst denselben vorhandenen Warenkorb-Button aus,
        damit Kaching weiterhin die aktuell ausgewählte Bundle-, Seiten- und
        Größenkombination verarbeitet. Sobald Shopify die Änderung im Warenkorb
        bestätigt, wird unmittelbar zum Checkout weitergeleitet.
      */
      if (directCheckoutButton && addButton) {
        let directCheckoutRunning = false;
        let checkoutTransitionOverlay = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const ensureCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay && document.body.contains(checkoutTransitionOverlay)) {
            return checkoutTransitionOverlay;
          }

          checkoutTransitionOverlay = document.createElement('div');
          checkoutTransitionOverlay.className = 'fb2-checkout-transition-overlay';
          checkoutTransitionOverlay.setAttribute('role', 'status');
          checkoutTransitionOverlay.setAttribute('aria-live', 'polite');
          checkoutTransitionOverlay.setAttribute('aria-label', 'Weiterleitung zum Checkout');
          checkoutTransitionOverlay.innerHTML = `
            <div class="fb2-checkout-transition-card">
              <span class="fb2-checkout-transition-spinner" aria-hidden="true"></span>
              <p class="fb2-checkout-transition-title">Weiterleitung zum sicheren Checkout …</p>
              <p class="fb2-checkout-transition-copy">Ihre ausgewählte Größe und Seite werden übernommen.</p>
            </div>
          `;

          document.body.appendChild(checkoutTransitionOverlay);
          return checkoutTransitionOverlay;
        };

        const showCheckoutTransitionOverlay = () => {
          const overlay = ensureCheckoutTransitionOverlay();

          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';

          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';

          overlay.classList.add('is-visible');
        };

        const hideCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay) {
            checkoutTransitionOverlay.classList.remove('is-visible');
          }

          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
        };

        const waitForVisiblePaint = () =>
          new Promise((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve);
            });
          });

        const setDirectCheckoutState = (loading, message = '') => {
          directCheckoutRunning = loading;
          directCheckoutButton.classList.toggle('is-loading', loading);
          directCheckoutButton.setAttribute('aria-busy', loading ? 'true' : 'false');

          /*
            Der normale Add-to-Cart-Ablauf bleibt für Kaching erhalten.
            Nur die sichtbare Warenkorb-Oberfläche wird bis zur Weiterleitung
            in den Checkout temporär unterdrückt.
          */
          document.documentElement.classList.toggle('fb2-direct-checkout-active', loading);
          if (document.body) {
            document.body.classList.toggle('fb2-direct-checkout-active', loading);
          }

          if (directCheckoutText) {
            directCheckoutText.textContent = loading
              ? directCheckoutButton.dataset.loadingText
              : directCheckoutButton.dataset.defaultText;
          }

          if (directCheckoutStatus) {
            directCheckoutStatus.textContent = message;
          }

          if (loading) {
            directCheckoutButton.disabled = true;
          } else {
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(idInput?.value)
            );
            directCheckoutButton.disabled = selectedVariant
              ? !selectedVariant.available
              : addButton.disabled;
          }
        };

        const getCartSnapshot = async () => {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
          });

          if (!response.ok) {
            throw new Error('Warenkorb konnte nicht gelesen werden.');
          }

          const cart = await response.json();

          return JSON.stringify({
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            items: (cart.items || []).map((item) => ({
              key: item.key,
              quantity: item.quantity,
              finalLinePrice: item.final_line_price,
              properties: item.properties || null,
            })),
          });
        };

        const waitForCartChange = async (beforeSnapshot, timeout = 10000) => {
          const startedAt = Date.now();

          while (Date.now() - startedAt < timeout) {
            await new Promise((resolve) => window.setTimeout(resolve, 180));

            try {
              const currentSnapshot = await getCartSnapshot();
              if (currentSnapshot !== beforeSnapshot) {
                return true;
              }
            } catch (error) {
              /* Kurze Netzwerkfehler werden bis zum Timeout erneut geprüft. */
            }
          }

          return false;
        };

        directCheckoutButton.addEventListener('click', async () => {
          if (directCheckoutRunning || addButton.disabled) return;

          setDirectCheckoutState(true, 'Ihre Auswahl wird für den Checkout vorbereitet …');
          showCheckoutTransitionOverlay();

          try {
            /*
              Zwei Render-Zyklen abwarten: Die weiße Übergangsebene ist damit
              garantiert sichtbar, bevor Kaching im Hintergrund den
              Warenkorb aktualisiert oder das Theme einen Drawer öffnet.
            */
            await waitForVisiblePaint();

            const beforeSnapshot = await getCartSnapshot();

            /*
              Der vorhandene Button bleibt die einzige Add-to-Cart-Logik.
              Dadurch bleiben Kaching-Auswahl und Bundle-Rabatt erhalten.
              Ein eventuell geöffneter Warenkorb liegt vollständig hinter der
              Übergangsebene und ist für den Kunden nicht sichtbar.
            */
            addButton.click();

            const cartChanged = await waitForCartChange(beforeSnapshot);

            if (!cartChanged) {
              throw new Error('Die Auswahl wurde nicht in den Warenkorb übernommen.');
            }

            window.location.replace('/checkout');
          } catch (error) {
            console.warn('Flex Buybox2: Direkter Checkout fehlgeschlagen.', error);
            hideCheckoutTransitionOverlay();
            setDirectCheckoutState(
              false,
              'Bitte prüfen Sie Größe, Seite und Bundle-Auswahl und versuchen Sie es erneut.'
            );
          }
        });

        window.addEventListener('pageshow', () => {
          hideCheckoutTransitionOverlay();
          setDirectCheckoutState(false, '');
        });
      }
    };

    const queuedRoots = new WeakSet();

    const hydrateRoot = (root) => {
      if (!root || root.dataset.flexBuybox2Initialized === 'true') return;
      initFlexBuybox2(root);
    };

    const scheduleRootHydration = (root) => {
      if (
        !root ||
        root.dataset.flexBuybox2Initialized === 'true' ||
        queuedRoots.has(root)
      ) {
        return;
      }

      queuedRoots.add(root);

      const run = () => {
        queuedRoots.delete(root);
        hydrateRoot(root);
      };

      /*
        Die PDP-Buybox liegt direkt im sichtbaren Bereich. Deshalb bleibt das
        Markup sofort sichtbar; nur die nicht kritische JavaScript-Hydrierung
        wird auf den nächsten Render-Zyklus verschoben, damit Bild, Titel und
        Preis zuerst gezeichnet werden können.
      */
      if (window.Shopify?.designMode || window.location.hash === '#bundle') {
        run();
      } else {
        window.requestAnimationFrame(run);
      }
    };

    const boot = (scope = document) => {
      if (scope.matches && scope.matches('.flex-buybox2')) {
        scheduleRootHydration(scope);
        return;
      }

      scope.querySelectorAll('.flex-buybox2').forEach(scheduleRootHydration);
    };

    const scrollToBundle = () => {
      const target = document.getElementById('bundle');
      if (!target) return;

      const root = target.closest('.flex-buybox2');
      if (root) hydrateRoot(root);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      });
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href="#bundle"]');
      if (!link) return;

      event.preventDefault();

      if (window.history?.pushState) {
        window.history.pushState(null, '', '#bundle');
      } else {
        window.location.hash = 'bundle';
      }

      scrollToBundle();
    });

    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          boot();

          if (window.location.hash === '#bundle') {
            scrollToBundle();
          }
        },
        { once: true }
      );
    } else {
      boot();

      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-buybox4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlexBuybox4 = (root) => {
      if (!root || root.dataset.flexBuybox4Initialized === 'true') return;
      root.dataset.flexBuybox4Initialized = 'true';
      root.classList.add('is-hydrated');

      /*
        Kaching wird erst erzeugt, wenn die Buybox in die Nähe des Viewports
        kommt. Das Custom Element bleibt bis dahin in einem inerten Template.
      */
      root.querySelectorAll('[data-kaching-deferred]').forEach((container) => {
        const template = container.querySelector('[data-kaching-template]');
        if (!template) return;
        container.appendChild(template.content.cloneNode(true));
        template.remove();
        container.removeAttribute('data-kaching-deferred');
      });

      const mediaButtons = Array.from(root.querySelectorAll('[data-media-target]'));
      const mediaPanels = Array.from(root.querySelectorAll('[data-media-id]'));
      const mainMedia = root.querySelector('.fb4-main-media');
      const galleryImages = Array.from(
        root.querySelectorAll('.fb4-media-panel img')
      );
      const galleryVideos = Array.from(
        root.querySelectorAll('[data-fb4-gallery-video]')
      );
      const externalGalleryVideos = Array.from(
        root.querySelectorAll('[data-fb4-external-video]')
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const floatingCartButton = root.querySelector('[data-floating-cart]');

      if (floatingCartButton) {
        const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;

        const openExistingCart = (event) => {
          event.preventDefault();

          /*
            UpCart stellt diese globale Funktion bereit, um den eigenen
            seitlichen Warenkorb zu öffnen. Es werden bewusst keine Methoden
            des ausgeblendeten Theme-Warenkorbs ausgelöst.
          */
          const openUpCart = () => {
            if (typeof window.upcartRegisterAddToCart !== 'function') {
              return false;
            }

            try {
              window.upcartRegisterAddToCart();
              return true;
            } catch (error) {
              console.warn('Flex Buybox4: UpCart konnte nicht geöffnet werden.', error);
              return false;
            }
          };

          if (openUpCart()) return;

          /*
            UpCart kann durch die App verzögert geladen werden. Deshalb wird
            die offizielle Funktion kurz abgewartet. Nur wenn sie gar nicht
            verfügbar wird, dient die normale Warenkorbseite als Fallback.
          */
          let attempts = 0;
          const maxAttempts = 20;

          const waitForUpCart = window.setInterval(() => {
            attempts += 1;

            if (openUpCart()) {
              window.clearInterval(waitForUpCart);
              return;
            }

            if (attempts >= maxAttempts) {
              window.clearInterval(waitForUpCart);
              window.location.assign(cartUrl);
            }
          }, 100);
        };

        floatingCartButton.addEventListener('click', openExistingCart);

        if ('IntersectionObserver' in window) {
          const floatingCartObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                floatingCartButton.classList.toggle(
                  'is-visible',
                  entry.isIntersecting
                );
              });
            },
            {
              threshold: 0.04,
              rootMargin: '-20px 0px -20px 0px',
            }
          );

          floatingCartObserver.observe(root);
        } else {
          floatingCartButton.classList.add('is-visible');
        }
      }

      galleryImages.forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';

        if ('fetchPriority' in image) {
          image.fetchPriority = 'low';
        }
      });

      const primePanelImage = (panel) => {
        const image = panel?.querySelector('img');
        if (!image) return;

        image.loading = 'eager';

        if ('fetchPriority' in image) {
          image.fetchPriority = 'high';
        }

        if (image.complete && typeof image.decode === 'function') {
          image.decode().catch(() => {});
        }
      };

      let activeMediaIndex = mediaPanels.findIndex(
        (panel) => panel.classList.contains('is-active') && !panel.hidden
      );
      let isMediaAnimating = false;
      let swipeState = null;

      if (activeMediaIndex < 0 && mediaPanels.length > 0) {
        activeMediaIndex = 0;
      }

      const wrappedMediaIndex = (index) => {
        if (!mediaPanels.length) return -1;
        return (index + mediaPanels.length) % mediaPanels.length;
      };

      const safelyResetNativeVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /*
            currentTime kann vor dem ersten Laden noch nicht gesetzt werden.
            Das Video bleibt trotzdem pausiert und wird beim Aktivieren auf 0 gesetzt.
          */
        }
      };

      const sendExternalVideoCommand = (iframe, command, value) => {
        if (!iframe?.contentWindow) return;

        const host = iframe.dataset.fb4VideoHost;

        if (host === 'youtube') {
          const args = typeof value === 'undefined' ? [] : [value];
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: command,
              args,
            }),
            '*'
          );
          return;
        }

        if (host === 'vimeo') {
          const payload = { method: command };
          if (typeof value !== 'undefined') payload.value = value;
          iframe.contentWindow.postMessage(payload, '*');
        }
      };

      const registerExternalVideoEvents = (iframe) => {
        if (!iframe || iframe.dataset.fb4EventsRegistered === 'true') return;
        iframe.dataset.fb4EventsRegistered = 'true';

        if (iframe.dataset.fb4VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'onStateChange');
        } else if (iframe.dataset.fb4VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'ended');
        }
      };

      const loadExternalVideo = (iframe) =>
        new Promise((resolve) => {
          if (!iframe) {
            resolve();
            return;
          }

          if (iframe.dataset.fb4Loaded === 'true') {
            resolve();
            return;
          }

          const source = iframe.dataset.src;
          if (!source) {
            resolve();
            return;
          }

          const finish = () => {
            iframe.dataset.fb4Loaded = 'true';
            registerExternalVideoEvents(iframe);
            resolve();
          };

          iframe.addEventListener('load', finish, { once: true });
          iframe.src = source;
        });

      const resetExternalVideo = (iframe) => {
        if (!iframe) return;

        iframe.dataset.fb4PlayToken = String(
          (Number(iframe.dataset.fb4PlayToken) || 0) + 1
        );

        if (iframe.dataset.fb4Loaded !== 'true') return;

        if (iframe.dataset.fb4VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'pauseVideo');
          sendExternalVideoCommand(iframe, 'seekTo', 0);
        } else if (iframe.dataset.fb4VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'pause');
          sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
        }
      };

      const playExternalVideo = async (iframe) => {
        if (!iframe) return;

        const playToken = String(
          (Number(iframe.dataset.fb4PlayToken) || 0) + 1
        );
        iframe.dataset.fb4PlayToken = playToken;

        await loadExternalVideo(iframe);

        const panel = iframe.closest('.fb4-media-panel');
        if (
          iframe.dataset.fb4PlayToken !== playToken ||
          !panel?.classList.contains('is-active') ||
          panel.hidden
        ) {
          return;
        }

        iframe.closest('.fb4-external-video-shell')?.classList.add('is-loaded');

        const play = () => {
          if (
            iframe.dataset.fb4PlayToken !== playToken ||
            !panel.classList.contains('is-active') ||
            panel.hidden
          ) {
            return;
          }

          if (iframe.dataset.fb4VideoHost === 'youtube') {
            sendExternalVideoCommand(iframe, 'mute');
            sendExternalVideoCommand(iframe, 'seekTo', 0);
            sendExternalVideoCommand(iframe, 'playVideo');
          } else if (iframe.dataset.fb4VideoHost === 'vimeo') {
            sendExternalVideoCommand(iframe, 'setVolume', 0);
            sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
            sendExternalVideoCommand(iframe, 'play');
          }
        };

        /*
          Einige externe Player benötigen nach dem iframe-load einen kurzen
          Moment, bevor sie API-Befehle annehmen. Die Wiederholung ist stumm
          und unsichtbar, erhöht aber die Zuverlässigkeit deutlich.
        */
        play();
        window.setTimeout(play, 180);
        window.setTimeout(play, 500);
      };

      const playNativeGalleryVideo = (video) => {
        if (!video) return;

        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
        video.preload = 'auto';

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Das Abspielen startet nach dem ersten Laden automatisch bei 0. */
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      galleryVideos.forEach((video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'none';

        video.addEventListener('ended', () => {
          safelyResetNativeVideo(video);
        });
      });

      const onExternalVideoMessage = (event) => {
        const iframe = externalGalleryVideos.find(
          (candidate) => candidate.contentWindow === event.source
        );
        if (!iframe) return;

        let payload = event.data;

        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (error) {
            return;
          }
        }

        const youtubeEnded =
          iframe.dataset.fb4VideoHost === 'youtube' &&
          payload?.event === 'onStateChange' &&
          Number(payload.info) === 0;

        const vimeoEnded =
          iframe.dataset.fb4VideoHost === 'vimeo' &&
          payload?.event === 'ended';

        if (youtubeEnded || vimeoEnded) {
          resetExternalVideo(iframe);
        }
      };

      if (externalGalleryVideos.length > 0) {
        window.addEventListener('message', onExternalVideoMessage);
      }

      const pausePanelVideos = (panel) => {
        if (!panel) return;

        panel.querySelectorAll('[data-fb4-gallery-video]').forEach((video) => {
          safelyResetNativeVideo(video);
        });

        panel.querySelectorAll('[data-fb4-external-video]').forEach((iframe) => {
          resetExternalVideo(iframe);
        });
      };

      const activatePanelMedia = (panel) => {
        if (!panel) return;

        primePanelImage(panel);

        if (mainMedia && mainMedia.dataset.fb4Visible !== 'true') {
          return;
        }

        panel.querySelectorAll('[data-fb4-gallery-video]').forEach((video) => {
          playNativeGalleryVideo(video);
        });

        panel.querySelectorAll('[data-fb4-external-video]').forEach((iframe) => {
          playExternalVideo(iframe);
        });
      };

      const updateMediaButtons = (activeIndex) => {
        const activeId = mediaPanels[activeIndex]?.dataset.mediaId;

        mediaButtons.forEach((button) => {
          const active = String(button.dataset.mediaTarget) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const resetPanelStyles = (panel) => {
        if (!panel) return;
        panel.classList.remove('is-media-animating');
        panel.style.transform = '';
      };

      const setActiveMedia = (targetIndex) => {
        if (targetIndex < 0 || !mediaPanels[targetIndex]) return;

        mediaPanels.forEach((panel, index) => {
          const active = index === targetIndex;

          resetPanelStyles(panel);
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            pausePanelVideos(panel);
          }
        });

        activeMediaIndex = targetIndex;
        updateMediaButtons(targetIndex);
        activatePanelMedia(mediaPanels[targetIndex]);
      };

      const finishMediaAnimation = (panel, callback) => {
        let completed = false;

        const finish = () => {
          if (completed) return;
          completed = true;
          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.propertyName === 'transform') {
            finish();
          }
        };

        panel.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 460);
      };

      const animateMediaTo = (targetIndex, direction) => {
        if (
          isMediaAnimating ||
          targetIndex < 0 ||
          targetIndex === activeMediaIndex ||
          !mediaPanels[targetIndex]
        ) {
          return;
        }

        if (!mobileMediaQuery.matches || reducedMotionQuery.matches) {
          setActiveMedia(targetIndex);
          return;
        }

        const currentPanel = mediaPanels[activeMediaIndex];
        const targetPanel = mediaPanels[targetIndex];
        const slideDirection = direction >= 0 ? 1 : -1;

        primePanelImage(targetPanel);
        isMediaAnimating = true;
        targetPanel.hidden = false;
        targetPanel.setAttribute('aria-hidden', 'false');
        currentPanel.classList.add('is-media-animating');
        targetPanel.classList.add('is-media-animating');

        currentPanel.style.transform = 'translate3d(0, 0, 0)';
        targetPanel.style.transform = `translate3d(${slideDirection * 100}%, 0, 0)`;

        targetPanel.getBoundingClientRect();

        requestAnimationFrame(() => {
          currentPanel.style.transform = `translate3d(${-slideDirection * 100}%, 0, 0)`;
          targetPanel.style.transform = 'translate3d(0, 0, 0)';
        });

        finishMediaAnimation(targetPanel, () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active');
          currentPanel.setAttribute('aria-hidden', 'true');
          pausePanelVideos(currentPanel);

          resetPanelStyles(currentPanel);
          resetPanelStyles(targetPanel);
          targetPanel.hidden = false;
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          activeMediaIndex = targetIndex;
          updateMediaButtons(targetIndex);
          activatePanelMedia(targetPanel);
          isMediaAnimating = false;
        });
      };

      const showMedia = (mediaId, options = {}) => {
        if (!mediaId) return;

        const targetIndex = mediaPanels.findIndex(
          (panel) => String(panel.dataset.mediaId) === String(mediaId)
        );

        if (targetIndex < 0 || targetIndex === activeMediaIndex) return;

        if (options.animate === true) {
          const direction = targetIndex > activeMediaIndex ? 1 : -1;
          animateMediaTo(targetIndex, direction);
        } else {
          setActiveMedia(targetIndex);
        }
      };

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMedia(button.dataset.mediaTarget, { animate: true });
        });
      });

      if (mainMedia && mediaPanels.length > 1) {
        mainMedia.addEventListener('dragstart', (event) => event.preventDefault());

        mainMedia.addEventListener(
          'touchstart',
          (event) => {
            if (
              !mobileMediaQuery.matches ||
              isMediaAnimating ||
              event.touches.length !== 1
            ) {
              return;
            }

            const touch = event.touches[0];

            swipeState = {
              startX: touch.clientX,
              startY: touch.clientY,
              currentX: touch.clientX,
              startTime: performance.now(),
              horizontal: null,
              direction: 0,
              targetIndex: -1,
              targetPanel: null,
            };
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeState || event.touches.length !== 1 || isMediaAnimating) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - swipeState.startX;
            const deltaY = touch.clientY - swipeState.startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            swipeState.currentX = touch.clientX;

            if (swipeState.horizontal === null) {
              if (Math.max(absoluteX, absoluteY) < 7) return;

              swipeState.horizontal = absoluteX > absoluteY;

              if (!swipeState.horizontal) {
                swipeState = null;
                return;
              }

              mainMedia.classList.add('is-swiping');
            }

            if (!swipeState.horizontal) return;

            event.preventDefault();

            const direction = deltaX < 0 ? 1 : -1;
            const targetIndex = wrappedMediaIndex(activeMediaIndex + direction);
            const currentPanel = mediaPanels[activeMediaIndex];

            if (
              direction !== swipeState.direction ||
              targetIndex !== swipeState.targetIndex
            ) {
              if (swipeState.targetPanel) {
                pausePanelVideos(swipeState.targetPanel);
                resetPanelStyles(swipeState.targetPanel);
                swipeState.targetPanel.hidden = true;
                swipeState.targetPanel.setAttribute('aria-hidden', 'true');
              }

              swipeState.direction = direction;
              swipeState.targetIndex = targetIndex;
              swipeState.targetPanel = mediaPanels[targetIndex];
              primePanelImage(swipeState.targetPanel);
              swipeState.targetPanel.hidden = false;
              swipeState.targetPanel.setAttribute('aria-hidden', 'false');
            }

            const width = mainMedia.clientWidth || 1;
            currentPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
            swipeState.targetPanel.style.transform =
              `translate3d(${direction * width + deltaX}px, 0, 0)`;
          },
          { passive: false }
        );

        const finishSwipe = (cancelled = false) => {
          if (!swipeState) return;

          const state = swipeState;
          swipeState = null;
          mainMedia.classList.remove('is-swiping');

          if (!state.horizontal || !state.targetPanel) {
            return;
          }

          const currentPanel = mediaPanels[activeMediaIndex];
          const targetPanel = state.targetPanel;
          const width = mainMedia.clientWidth || 1;
          const deltaX = state.currentX - state.startX;
          const elapsed = Math.max(performance.now() - state.startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed;
          const shouldChange =
            !cancelled &&
            (Math.abs(deltaX) >= Math.min(58, width * 0.18) || velocity > 0.45);

          isMediaAnimating = true;
          currentPanel.classList.add('is-media-animating');
          targetPanel.classList.add('is-media-animating');

          requestAnimationFrame(() => {
            if (shouldChange) {
              currentPanel.style.transform =
                `translate3d(${-state.direction * width}px, 0, 0)`;
              targetPanel.style.transform = 'translate3d(0, 0, 0)';
            } else {
              currentPanel.style.transform = 'translate3d(0, 0, 0)';
              targetPanel.style.transform =
                `translate3d(${state.direction * width}px, 0, 0)`;
            }
          });

          finishMediaAnimation(shouldChange ? targetPanel : currentPanel, () => {
            resetPanelStyles(currentPanel);
            resetPanelStyles(targetPanel);

            if (shouldChange) {
              currentPanel.hidden = true;
              currentPanel.classList.remove('is-active');
              currentPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(currentPanel);

              targetPanel.hidden = false;
              targetPanel.classList.add('is-active');
              targetPanel.setAttribute('aria-hidden', 'false');

              activeMediaIndex = state.targetIndex;
              updateMediaButtons(activeMediaIndex);
              activatePanelMedia(targetPanel);
            } else {
              currentPanel.hidden = false;
              currentPanel.classList.add('is-active');
              currentPanel.setAttribute('aria-hidden', 'false');

              targetPanel.hidden = true;
              targetPanel.classList.remove('is-active');
              targetPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(targetPanel);
            }

            isMediaAnimating = false;
          });
        };

        mainMedia.addEventListener('touchend', () => finishSwipe(false), {
          passive: true,
        });

        mainMedia.addEventListener('touchcancel', () => finishSwipe(true), {
          passive: true,
        });
      }

      if (mainMedia) {
        if ('IntersectionObserver' in window) {
          const galleryVisibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.06 &&
                  document.visibilityState !== 'hidden';

                mainMedia.dataset.fb4Visible = visible ? 'true' : 'false';

                if (visible) {
                  activatePanelMedia(mediaPanels[activeMediaIndex]);
                } else {
                  mediaPanels.forEach((panel) => pausePanelVideos(panel));
                }
              });
            },
            {
              threshold: [0, 0.06, 0.2],
              rootMargin: '30px 0px',
            }
          );

          galleryVisibilityObserver.observe(mainMedia);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              mainMedia.dataset.fb4Visible = 'false';
              mediaPanels.forEach((panel) => pausePanelVideos(panel));
              return;
            }

            const rect = mainMedia.getBoundingClientRect();
            const visible =
              rect.bottom > 0 &&
              rect.top < window.innerHeight &&
              rect.right > 0 &&
              rect.left < window.innerWidth;

            mainMedia.dataset.fb4Visible = visible ? 'true' : 'false';

            if (visible) {
              activatePanelMedia(mediaPanels[activeMediaIndex]);
            }
          });
        } else {
          mainMedia.dataset.fb4Visible = 'true';
        }
      }

      if (mediaPanels.length > 0) {
        setActiveMedia(activeMediaIndex);
      }

      const autoplayVideos = Array.from(
        root.querySelectorAll('[data-fb4-autoplay-video]')
      );

      const setLoopingVideoState = (video, shouldPlay) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');

        if (!shouldPlay) {
          video.pause();
          return;
        }

        video.preload = 'metadata';
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      autoplayVideos.forEach((video) => {
        setLoopingVideoState(video, false);
      });

      if (autoplayVideos.length > 0) {
        if ('IntersectionObserver' in window) {
          const loopingVideoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const shouldPlay =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.12 &&
                  document.visibilityState !== 'hidden';

                setLoopingVideoState(entry.target, shouldPlay);
              });
            },
            {
              threshold: [0, 0.12, 0.35],
              rootMargin: '80px 0px',
            }
          );

          autoplayVideos.forEach((video) => loopingVideoObserver.observe(video));

          document.addEventListener('visibilitychange', () => {
            autoplayVideos.forEach((video) => {
              if (document.visibilityState === 'hidden') {
                setLoopingVideoState(video, false);
                return;
              }

              const rect = video.getBoundingClientRect();
              const visible =
                rect.bottom > 0 &&
                rect.top < window.innerHeight &&
                rect.right > 0 &&
                rect.left < window.innerWidth;

              setLoopingVideoState(video, visible);
            });
          });
        } else {
          autoplayVideos.forEach((video) => setLoopingVideoState(video, true));
        }
      }

      const faq = root.querySelector('.fb4-faq');

      if (faq) {
        const faqItems = Array.from(faq.querySelectorAll('.fb4-faq-item'));
        const closingStates = new WeakMap();
        const faqTransitionDuration = 380;

        const cancelScheduledClose = (item) => {
          const state = closingStates.get(item);
          if (!state) return;

          state.panel.removeEventListener('transitionend', state.onTransitionEnd);
          window.clearTimeout(state.timeoutId);
          closingStates.delete(item);
        };

        const finalizeFaqClose = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-open', 'is-closing');
          item.removeAttribute('open');
        };

        const openFaqItem = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-closing');

          if (!item.open) {
            item.setAttribute('open', '');
          }

          if (reducedMotionQuery.matches) {
            item.classList.add('is-open');
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.add('is-open');
            });
          });
        };

        const closeFaqItem = (item) => {
          if (!item.open) return;

          cancelScheduledClose(item);
          item.classList.add('is-closing');
          item.classList.remove('is-open');

          if (reducedMotionQuery.matches) {
            finalizeFaqClose(item);
            return;
          }

          const panel = item.querySelector('.fb4-faq-panel');
          if (!panel) {
            finalizeFaqClose(item);
            return;
          }

          const onTransitionEnd = (event) => {
            if (
              event.target === panel &&
              event.propertyName === 'grid-template-rows'
            ) {
              finalizeFaqClose(item);
            }
          };

          panel.addEventListener('transitionend', onTransitionEnd);

          const timeoutId = window.setTimeout(
            () => finalizeFaqClose(item),
            faqTransitionDuration
          );

          closingStates.set(item, {
            panel,
            onTransitionEnd,
            timeoutId,
          });
        };

        faqItems.forEach((item) => {
          if (item.open) {
            item.classList.add('is-open');
          }
        });

        faq.addEventListener('click', (event) => {
          const summary = event.target.closest('.fb4-faq-item > summary');
          if (!summary || !faq.contains(summary)) return;

          event.preventDefault();

          const selectedItem = summary.parentElement;
          const selectedIsOpen =
            selectedItem.open &&
            selectedItem.classList.contains('is-open') &&
            !selectedItem.classList.contains('is-closing');

          faqItems.forEach((item) => {
            if (item !== selectedItem && item.open) {
              closeFaqItem(item);
            }
          });

          if (selectedIsOpen) {
            closeFaqItem(selectedItem);
          } else {
            openFaqItem(selectedItem);
          }
        });
      }

      const variantsScript = root.querySelector('[data-flex4-variants]');
      const form = root.querySelector('.fb4-product-form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.warn('Flex Buybox4: Variantendaten konnten nicht gelesen werden.', error);
        return;
      }

      const idInput = form.querySelector('[data-variant-id]');
      const optionSelects = form.querySelectorAll('[data-option-position]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addButtonText = form.querySelector('[data-add-button-text]');
      const directCheckoutButton = form.querySelector('[data-direct-checkout]');
      const directCheckoutText = form.querySelector('[data-direct-checkout-text]');
      const directCheckoutStatus = form.querySelector('[data-direct-checkout-status]');
      const priceElement = root.querySelector('[data-product-price]');
      const comparePriceElement = root.querySelector('[data-compare-price]');
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || 'de-DE';
      const updateUrl = root.dataset.updateVariantUrl === 'true';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      let internalVariantUpdate = false;

      const updateVariant = (variant, { syncInput = true } = {}) => {
        if (!variant || !idInput) return;

        if (syncInput) {
          internalVariantUpdate = true;
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          internalVariantUpdate = false;
        }

        if (priceElement) priceElement.textContent = formatMoney(variant.price);

        if (comparePriceElement) {
          const showCompare = Number(variant.compare_at_price) > Number(variant.price);
          comparePriceElement.classList.toggle('is-hidden', !showCompare);
          comparePriceElement.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        }

        if (addButton && addButtonText) {
          addButton.disabled = !variant.available;
          addButtonText.textContent = variant.available
            ? addButton.dataset.availableText
            : addButton.dataset.soldoutText;
        }

        if (directCheckoutButton) {
          directCheckoutButton.disabled = !variant.available;
        }

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant },
          })
        );
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(optionSelects)
            .sort(
              (a, b) =>
                Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
            )
            .map((input) => input.value);

          const matchedVariant = variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          updateVariant(matchedVariant);
        });
      });

      if (idInput) {
        idInput.addEventListener('change', () => {
          if (internalVariantUpdate) return;
          const matchedVariant = variants.find(
            (variant) => String(variant.id) === String(idInput.value)
          );
          if (matchedVariant) updateVariant(matchedVariant, { syncInput: false });
        });
      }

      /*
        Eigener Direkt-zur-Kasse-Button.

        Der Button löst bewusst denselben vorhandenen Warenkorb-Button aus,
        damit Kaching weiterhin die aktuell ausgewählte Bundle-, Seiten- und
        Größenkombination verarbeitet. Sobald Shopify die Änderung im Warenkorb
        bestätigt, wird unmittelbar zum Checkout weitergeleitet.
      */
      if (directCheckoutButton && addButton) {
        let directCheckoutRunning = false;
        let checkoutTransitionOverlay = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const ensureCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay && document.body.contains(checkoutTransitionOverlay)) {
            return checkoutTransitionOverlay;
          }

          checkoutTransitionOverlay = document.createElement('div');
          checkoutTransitionOverlay.className = 'fb4-checkout-transition-overlay';
          checkoutTransitionOverlay.setAttribute('role', 'status');
          checkoutTransitionOverlay.setAttribute('aria-live', 'polite');
          checkoutTransitionOverlay.setAttribute('aria-label', 'Weiterleitung zum Checkout');
          checkoutTransitionOverlay.innerHTML = `
            <div class="fb4-checkout-transition-card">
              <span class="fb4-checkout-transition-spinner" aria-hidden="true"></span>
              <p class="fb4-checkout-transition-title">Weiterleitung zum sicheren Checkout …</p>
              <p class="fb4-checkout-transition-copy">Ihre ausgewählte Größe und Seite werden übernommen.</p>
            </div>
          `;

          document.body.appendChild(checkoutTransitionOverlay);
          return checkoutTransitionOverlay;
        };

        const showCheckoutTransitionOverlay = () => {
          const overlay = ensureCheckoutTransitionOverlay();

          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';

          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';

          overlay.classList.add('is-visible');
        };

        const hideCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay) {
            checkoutTransitionOverlay.classList.remove('is-visible');
          }

          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
        };

        const waitForVisiblePaint = () =>
          new Promise((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve);
            });
          });

        const setDirectCheckoutState = (loading, message = '') => {
          directCheckoutRunning = loading;
          directCheckoutButton.classList.toggle('is-loading', loading);
          directCheckoutButton.setAttribute('aria-busy', loading ? 'true' : 'false');

          /*
            Der normale Add-to-Cart-Ablauf bleibt für Kaching erhalten.
            Nur die sichtbare Warenkorb-Oberfläche wird bis zur Weiterleitung
            in den Checkout temporär unterdrückt.
          */
          document.documentElement.classList.toggle('fb4-direct-checkout-active', loading);
          if (document.body) {
            document.body.classList.toggle('fb4-direct-checkout-active', loading);
          }

          if (directCheckoutText) {
            directCheckoutText.textContent = loading
              ? directCheckoutButton.dataset.loadingText
              : directCheckoutButton.dataset.defaultText;
          }

          if (directCheckoutStatus) {
            directCheckoutStatus.textContent = message;
          }

          if (loading) {
            directCheckoutButton.disabled = true;
          } else {
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(idInput?.value)
            );
            directCheckoutButton.disabled = selectedVariant
              ? !selectedVariant.available
              : addButton.disabled;
          }
        };

        const getCartSnapshot = async () => {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
          });

          if (!response.ok) {
            throw new Error('Warenkorb konnte nicht gelesen werden.');
          }

          const cart = await response.json();

          return JSON.stringify({
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            items: (cart.items || []).map((item) => ({
              key: item.key,
              quantity: item.quantity,
              finalLinePrice: item.final_line_price,
              properties: item.properties || null,
            })),
          });
        };

        const waitForCartChange = async (beforeSnapshot, timeout = 10000) => {
          const startedAt = Date.now();

          while (Date.now() - startedAt < timeout) {
            await new Promise((resolve) => window.setTimeout(resolve, 180));

            try {
              const currentSnapshot = await getCartSnapshot();
              if (currentSnapshot !== beforeSnapshot) {
                return true;
              }
            } catch (error) {
              /* Kurze Netzwerkfehler werden bis zum Timeout erneut geprüft. */
            }
          }

          return false;
        };

        directCheckoutButton.addEventListener('click', async () => {
          if (directCheckoutRunning || addButton.disabled) return;

          setDirectCheckoutState(true, 'Ihre Auswahl wird für den Checkout vorbereitet …');
          showCheckoutTransitionOverlay();

          try {
            /*
              Zwei Render-Zyklen abwarten: Die weiße Übergangsebene ist damit
              garantiert sichtbar, bevor Kaching im Hintergrund den
              Warenkorb aktualisiert oder das Theme einen Drawer öffnet.
            */
            await waitForVisiblePaint();

            const beforeSnapshot = await getCartSnapshot();

            /*
              Der vorhandene Button bleibt die einzige Add-to-Cart-Logik.
              Dadurch bleiben Kaching-Auswahl und Bundle-Rabatt erhalten.
              Ein eventuell geöffneter Warenkorb liegt vollständig hinter der
              Übergangsebene und ist für den Kunden nicht sichtbar.
            */
            addButton.click();

            const cartChanged = await waitForCartChange(beforeSnapshot);

            if (!cartChanged) {
              throw new Error('Die Auswahl wurde nicht in den Warenkorb übernommen.');
            }

            window.location.replace('/checkout');
          } catch (error) {
            console.warn('Flex Buybox4: Direkter Checkout fehlgeschlagen.', error);
            hideCheckoutTransitionOverlay();
            setDirectCheckoutState(
              false,
              'Bitte prüfen Sie Größe, Seite und Bundle-Auswahl und versuchen Sie es erneut.'
            );
          }
        });

        window.addEventListener('pageshow', () => {
          hideCheckoutTransitionOverlay();
          setDirectCheckoutState(false, '');
        });
      }
    };

    const observedRoots = new WeakSet();
    const hydrationObservers = new WeakMap();

    const hydrateRoot = (root) => {
      if (!root || root.dataset.flexBuybox4Initialized === 'true') return;

      const observer = hydrationObservers.get(root);
      if (observer) {
        observer.disconnect();
        hydrationObservers.delete(root);
      }

      initFlexBuybox4(root);
    };

    const observeRoot = (root) => {
      if (
        !root ||
        root.dataset.flexBuybox4Initialized === 'true' ||
        observedRoots.has(root)
      ) {
        return;
      }

      observedRoots.add(root);

      const bundleTarget = root.querySelector('#bundle');
      const isHashTarget =
        window.location.hash === '#bundle' &&
        bundleTarget &&
        document.getElementById('bundle') === bundleTarget;

      if (
        isHashTarget ||
        window.Shopify?.designMode ||
        !('IntersectionObserver' in window)
      ) {
        hydrateRoot(root);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            hydrateRoot(root);
          }
        },
        {
          /*
            900 px Vorlauf: Die Buybox ist vollständig bereit, bevor der Kunde
            sie erreicht, belastet aber den initialen Seitenaufruf nicht.
          */
          rootMargin: '900px 0px',
          threshold: 0.01,
        }
      );

      hydrationObservers.set(root, observer);
      observer.observe(root);
    };

    const boot = (scope = document) => {
      if (scope.matches && scope.matches('.flex-buybox4')) {
        observeRoot(scope);
        return;
      }

      scope.querySelectorAll('.flex-buybox4').forEach(observeRoot);
    };

    const scrollToBundle = () => {
      const target = document.getElementById('bundle');
      if (!target) return;

      const root = target.closest('.flex-buybox4');
      if (root) hydrateRoot(root);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      });
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href="#bundle"]');
      if (!link) return;

      event.preventDefault();

      if (window.history?.pushState) {
        window.history.pushState(null, '', '#bundle');
      } else {
        window.location.hash = 'bundle';
      }

      scrollToBundle();
    });

    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          boot();

          if (window.location.hash === '#bundle') {
            scrollToBundle();
          }
        },
        { once: true }
      );
    } else {
      boot();

      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexbuybox-Presell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlexBuybox3 = (root) => {
      if (!root || root.dataset.flexBuybox3Initialized === 'true') return;
      root.dataset.flexBuybox3Initialized = 'true';
      root.classList.add('is-hydrated');

      /*
        Kaching wird erst erzeugt, wenn die Buybox in die Nähe des Viewports
        kommt. Das Custom Element bleibt bis dahin in einem inerten Template.
      */
      root.querySelectorAll('[data-kaching-deferred]').forEach((container) => {
        const template = container.querySelector('[data-kaching-template]');
        if (!template) return;
        container.appendChild(template.content.cloneNode(true));
        template.remove();
        container.removeAttribute('data-kaching-deferred');
      });

      const mediaButtons = Array.from(root.querySelectorAll('[data-media-target]'));
      const mediaPanels = Array.from(root.querySelectorAll('[data-media-id]'));
      const mainMedia = root.querySelector('.fb3-main-media');
      const galleryImages = Array.from(
        root.querySelectorAll('.fb3-media-panel img')
      );
      const galleryVideos = Array.from(
        root.querySelectorAll('[data-fb3-gallery-video]')
      );
      const externalGalleryVideos = Array.from(
        root.querySelectorAll('[data-fb3-external-video]')
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const floatingCartButton = root.querySelector('[data-floating-cart]');

      if (floatingCartButton) {
        const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;

        const openExistingCart = (event) => {
          event.preventDefault();

          /*
            UpCart stellt diese globale Funktion bereit, um den eigenen
            seitlichen Warenkorb zu öffnen. Es werden bewusst keine Methoden
            des ausgeblendeten Theme-Warenkorbs ausgelöst.
          */
          const openUpCart = () => {
            if (typeof window.upcartRegisterAddToCart !== 'function') {
              return false;
            }

            try {
              window.upcartRegisterAddToCart();
              return true;
            } catch (error) {
              console.warn('Flex Buybox3: UpCart konnte nicht geöffnet werden.', error);
              return false;
            }
          };

          if (openUpCart()) return;

          /*
            UpCart kann durch die App verzögert geladen werden. Deshalb wird
            die offizielle Funktion kurz abgewartet. Nur wenn sie gar nicht
            verfügbar wird, dient die normale Warenkorbseite als Fallback.
          */
          let attempts = 0;
          const maxAttempts = 20;

          const waitForUpCart = window.setInterval(() => {
            attempts += 1;

            if (openUpCart()) {
              window.clearInterval(waitForUpCart);
              return;
            }

            if (attempts >= maxAttempts) {
              window.clearInterval(waitForUpCart);
              window.location.assign(cartUrl);
            }
          }, 100);
        };

        floatingCartButton.addEventListener('click', openExistingCart);

        if ('IntersectionObserver' in window) {
          const floatingCartObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                floatingCartButton.classList.toggle(
                  'is-visible',
                  entry.isIntersecting
                );
              });
            },
            {
              threshold: 0.04,
              rootMargin: '-20px 0px -20px 0px',
            }
          );

          floatingCartObserver.observe(root);
        } else {
          floatingCartButton.classList.add('is-visible');
        }
      }

      galleryImages.forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';

        if ('fetchPriority' in image) {
          image.fetchPriority = 'low';
        }
      });

      const primePanelImage = (panel) => {
        const image = panel?.querySelector('img');
        if (!image) return;

        image.loading = 'eager';

        if ('fetchPriority' in image) {
          image.fetchPriority = 'high';
        }

        if (image.complete && typeof image.decode === 'function') {
          image.decode().catch(() => {});
        }
      };

      let activeMediaIndex = mediaPanels.findIndex(
        (panel) => panel.classList.contains('is-active') && !panel.hidden
      );
      let isMediaAnimating = false;
      let swipeState = null;

      if (activeMediaIndex < 0 && mediaPanels.length > 0) {
        activeMediaIndex = 0;
      }

      const wrappedMediaIndex = (index) => {
        if (!mediaPanels.length) return -1;
        return (index + mediaPanels.length) % mediaPanels.length;
      };

      const safelyResetNativeVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /*
            currentTime kann vor dem ersten Laden noch nicht gesetzt werden.
            Das Video bleibt trotzdem pausiert und wird beim Aktivieren auf 0 gesetzt.
          */
        }
      };

      const sendExternalVideoCommand = (iframe, command, value) => {
        if (!iframe?.contentWindow) return;

        const host = iframe.dataset.fb3VideoHost;

        if (host === 'youtube') {
          const args = typeof value === 'undefined' ? [] : [value];
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: command,
              args,
            }),
            '*'
          );
          return;
        }

        if (host === 'vimeo') {
          const payload = { method: command };
          if (typeof value !== 'undefined') payload.value = value;
          iframe.contentWindow.postMessage(payload, '*');
        }
      };

      const registerExternalVideoEvents = (iframe) => {
        if (!iframe || iframe.dataset.fb3EventsRegistered === 'true') return;
        iframe.dataset.fb3EventsRegistered = 'true';

        if (iframe.dataset.fb3VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'onStateChange');
        } else if (iframe.dataset.fb3VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'addEventListener', 'ended');
        }
      };

      const loadExternalVideo = (iframe) =>
        new Promise((resolve) => {
          if (!iframe) {
            resolve();
            return;
          }

          if (iframe.dataset.fb3Loaded === 'true') {
            resolve();
            return;
          }

          const source = iframe.dataset.src;
          if (!source) {
            resolve();
            return;
          }

          const finish = () => {
            iframe.dataset.fb3Loaded = 'true';
            registerExternalVideoEvents(iframe);
            resolve();
          };

          iframe.addEventListener('load', finish, { once: true });
          iframe.src = source;
        });

      const resetExternalVideo = (iframe) => {
        if (!iframe) return;

        iframe.dataset.fb3PlayToken = String(
          (Number(iframe.dataset.fb3PlayToken) || 0) + 1
        );

        if (iframe.dataset.fb3Loaded !== 'true') return;

        if (iframe.dataset.fb3VideoHost === 'youtube') {
          sendExternalVideoCommand(iframe, 'pauseVideo');
          sendExternalVideoCommand(iframe, 'seekTo', 0);
        } else if (iframe.dataset.fb3VideoHost === 'vimeo') {
          sendExternalVideoCommand(iframe, 'pause');
          sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
        }
      };

      const playExternalVideo = async (iframe) => {
        if (!iframe) return;

        const playToken = String(
          (Number(iframe.dataset.fb3PlayToken) || 0) + 1
        );
        iframe.dataset.fb3PlayToken = playToken;

        await loadExternalVideo(iframe);

        const panel = iframe.closest('.fb3-media-panel');
        if (
          iframe.dataset.fb3PlayToken !== playToken ||
          !panel?.classList.contains('is-active') ||
          panel.hidden
        ) {
          return;
        }

        iframe.closest('.fb3-external-video-shell')?.classList.add('is-loaded');

        const play = () => {
          if (
            iframe.dataset.fb3PlayToken !== playToken ||
            !panel.classList.contains('is-active') ||
            panel.hidden
          ) {
            return;
          }

          if (iframe.dataset.fb3VideoHost === 'youtube') {
            sendExternalVideoCommand(iframe, 'mute');
            sendExternalVideoCommand(iframe, 'seekTo', 0);
            sendExternalVideoCommand(iframe, 'playVideo');
          } else if (iframe.dataset.fb3VideoHost === 'vimeo') {
            sendExternalVideoCommand(iframe, 'setVolume', 0);
            sendExternalVideoCommand(iframe, 'setCurrentTime', 0);
            sendExternalVideoCommand(iframe, 'play');
          }
        };

        /*
          Einige externe Player benötigen nach dem iframe-load einen kurzen
          Moment, bevor sie API-Befehle annehmen. Die Wiederholung ist stumm
          und unsichtbar, erhöht aber die Zuverlässigkeit deutlich.
        */
        play();
        window.setTimeout(play, 180);
        window.setTimeout(play, 500);
      };

      const playNativeGalleryVideo = (video) => {
        if (!video) return;

        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
        video.preload = 'auto';

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Das Abspielen startet nach dem ersten Laden automatisch bei 0. */
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      galleryVideos.forEach((video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.loop = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'none';

        video.addEventListener('ended', () => {
          safelyResetNativeVideo(video);
        });
      });

      const onExternalVideoMessage = (event) => {
        const iframe = externalGalleryVideos.find(
          (candidate) => candidate.contentWindow === event.source
        );
        if (!iframe) return;

        let payload = event.data;

        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (error) {
            return;
          }
        }

        const youtubeEnded =
          iframe.dataset.fb3VideoHost === 'youtube' &&
          payload?.event === 'onStateChange' &&
          Number(payload.info) === 0;

        const vimeoEnded =
          iframe.dataset.fb3VideoHost === 'vimeo' &&
          payload?.event === 'ended';

        if (youtubeEnded || vimeoEnded) {
          resetExternalVideo(iframe);
        }
      };

      if (externalGalleryVideos.length > 0) {
        window.addEventListener('message', onExternalVideoMessage);
      }

      const pausePanelVideos = (panel) => {
        if (!panel) return;

        panel.querySelectorAll('[data-fb3-gallery-video]').forEach((video) => {
          safelyResetNativeVideo(video);
        });

        panel.querySelectorAll('[data-fb3-external-video]').forEach((iframe) => {
          resetExternalVideo(iframe);
        });
      };

      const activatePanelMedia = (panel) => {
        if (!panel) return;

        primePanelImage(panel);

        if (mainMedia && mainMedia.dataset.fb3Visible !== 'true') {
          return;
        }

        panel.querySelectorAll('[data-fb3-gallery-video]').forEach((video) => {
          playNativeGalleryVideo(video);
        });

        panel.querySelectorAll('[data-fb3-external-video]').forEach((iframe) => {
          playExternalVideo(iframe);
        });
      };

      const updateMediaButtons = (activeIndex) => {
        const activeId = mediaPanels[activeIndex]?.dataset.mediaId;

        mediaButtons.forEach((button) => {
          const active = String(button.dataset.mediaTarget) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const resetPanelStyles = (panel) => {
        if (!panel) return;
        panel.classList.remove('is-media-animating');
        panel.style.transform = '';
      };

      const setActiveMedia = (targetIndex) => {
        if (targetIndex < 0 || !mediaPanels[targetIndex]) return;

        mediaPanels.forEach((panel, index) => {
          const active = index === targetIndex;

          resetPanelStyles(panel);
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            pausePanelVideos(panel);
          }
        });

        activeMediaIndex = targetIndex;
        updateMediaButtons(targetIndex);
        activatePanelMedia(mediaPanels[targetIndex]);
      };

      const finishMediaAnimation = (panel, callback) => {
        let completed = false;

        const finish = () => {
          if (completed) return;
          completed = true;
          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.propertyName === 'transform') {
            finish();
          }
        };

        panel.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 460);
      };

      const animateMediaTo = (targetIndex, direction) => {
        if (
          isMediaAnimating ||
          targetIndex < 0 ||
          targetIndex === activeMediaIndex ||
          !mediaPanels[targetIndex]
        ) {
          return;
        }

        if (!mobileMediaQuery.matches || reducedMotionQuery.matches) {
          setActiveMedia(targetIndex);
          return;
        }

        const currentPanel = mediaPanels[activeMediaIndex];
        const targetPanel = mediaPanels[targetIndex];
        const slideDirection = direction >= 0 ? 1 : -1;

        primePanelImage(targetPanel);
        isMediaAnimating = true;
        targetPanel.hidden = false;
        targetPanel.setAttribute('aria-hidden', 'false');
        currentPanel.classList.add('is-media-animating');
        targetPanel.classList.add('is-media-animating');

        currentPanel.style.transform = 'translate3d(0, 0, 0)';
        targetPanel.style.transform = `translate3d(${slideDirection * 100}%, 0, 0)`;

        targetPanel.getBoundingClientRect();

        requestAnimationFrame(() => {
          currentPanel.style.transform = `translate3d(${-slideDirection * 100}%, 0, 0)`;
          targetPanel.style.transform = 'translate3d(0, 0, 0)';
        });

        finishMediaAnimation(targetPanel, () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active');
          currentPanel.setAttribute('aria-hidden', 'true');
          pausePanelVideos(currentPanel);

          resetPanelStyles(currentPanel);
          resetPanelStyles(targetPanel);
          targetPanel.hidden = false;
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          activeMediaIndex = targetIndex;
          updateMediaButtons(targetIndex);
          activatePanelMedia(targetPanel);
          isMediaAnimating = false;
        });
      };

      const showMedia = (mediaId, options = {}) => {
        if (!mediaId) return;

        const targetIndex = mediaPanels.findIndex(
          (panel) => String(panel.dataset.mediaId) === String(mediaId)
        );

        if (targetIndex < 0 || targetIndex === activeMediaIndex) return;

        if (options.animate === true) {
          const direction = targetIndex > activeMediaIndex ? 1 : -1;
          animateMediaTo(targetIndex, direction);
        } else {
          setActiveMedia(targetIndex);
        }
      };

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMedia(button.dataset.mediaTarget, { animate: true });
        });
      });

      if (mainMedia && mediaPanels.length > 1) {
        mainMedia.addEventListener('dragstart', (event) => event.preventDefault());

        mainMedia.addEventListener(
          'touchstart',
          (event) => {
            if (
              !mobileMediaQuery.matches ||
              isMediaAnimating ||
              event.touches.length !== 1
            ) {
              return;
            }

            const touch = event.touches[0];

            swipeState = {
              startX: touch.clientX,
              startY: touch.clientY,
              currentX: touch.clientX,
              startTime: performance.now(),
              horizontal: null,
              direction: 0,
              targetIndex: -1,
              targetPanel: null,
            };
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeState || event.touches.length !== 1 || isMediaAnimating) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - swipeState.startX;
            const deltaY = touch.clientY - swipeState.startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            swipeState.currentX = touch.clientX;

            if (swipeState.horizontal === null) {
              if (Math.max(absoluteX, absoluteY) < 7) return;

              swipeState.horizontal = absoluteX > absoluteY;

              if (!swipeState.horizontal) {
                swipeState = null;
                return;
              }

              mainMedia.classList.add('is-swiping');
            }

            if (!swipeState.horizontal) return;

            event.preventDefault();

            const direction = deltaX < 0 ? 1 : -1;
            const targetIndex = wrappedMediaIndex(activeMediaIndex + direction);
            const currentPanel = mediaPanels[activeMediaIndex];

            if (
              direction !== swipeState.direction ||
              targetIndex !== swipeState.targetIndex
            ) {
              if (swipeState.targetPanel) {
                pausePanelVideos(swipeState.targetPanel);
                resetPanelStyles(swipeState.targetPanel);
                swipeState.targetPanel.hidden = true;
                swipeState.targetPanel.setAttribute('aria-hidden', 'true');
              }

              swipeState.direction = direction;
              swipeState.targetIndex = targetIndex;
              swipeState.targetPanel = mediaPanels[targetIndex];
              primePanelImage(swipeState.targetPanel);
              swipeState.targetPanel.hidden = false;
              swipeState.targetPanel.setAttribute('aria-hidden', 'false');
            }

            const width = mainMedia.clientWidth || 1;
            currentPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
            swipeState.targetPanel.style.transform =
              `translate3d(${direction * width + deltaX}px, 0, 0)`;
          },
          { passive: false }
        );

        const finishSwipe = (cancelled = false) => {
          if (!swipeState) return;

          const state = swipeState;
          swipeState = null;
          mainMedia.classList.remove('is-swiping');

          if (!state.horizontal || !state.targetPanel) {
            return;
          }

          const currentPanel = mediaPanels[activeMediaIndex];
          const targetPanel = state.targetPanel;
          const width = mainMedia.clientWidth || 1;
          const deltaX = state.currentX - state.startX;
          const elapsed = Math.max(performance.now() - state.startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed;
          const shouldChange =
            !cancelled &&
            (Math.abs(deltaX) >= Math.min(58, width * 0.18) || velocity > 0.45);

          isMediaAnimating = true;
          currentPanel.classList.add('is-media-animating');
          targetPanel.classList.add('is-media-animating');

          requestAnimationFrame(() => {
            if (shouldChange) {
              currentPanel.style.transform =
                `translate3d(${-state.direction * width}px, 0, 0)`;
              targetPanel.style.transform = 'translate3d(0, 0, 0)';
            } else {
              currentPanel.style.transform = 'translate3d(0, 0, 0)';
              targetPanel.style.transform =
                `translate3d(${state.direction * width}px, 0, 0)`;
            }
          });

          finishMediaAnimation(shouldChange ? targetPanel : currentPanel, () => {
            resetPanelStyles(currentPanel);
            resetPanelStyles(targetPanel);

            if (shouldChange) {
              currentPanel.hidden = true;
              currentPanel.classList.remove('is-active');
              currentPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(currentPanel);

              targetPanel.hidden = false;
              targetPanel.classList.add('is-active');
              targetPanel.setAttribute('aria-hidden', 'false');

              activeMediaIndex = state.targetIndex;
              updateMediaButtons(activeMediaIndex);
              activatePanelMedia(targetPanel);
            } else {
              currentPanel.hidden = false;
              currentPanel.classList.add('is-active');
              currentPanel.setAttribute('aria-hidden', 'false');

              targetPanel.hidden = true;
              targetPanel.classList.remove('is-active');
              targetPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(targetPanel);
            }

            isMediaAnimating = false;
          });
        };

        mainMedia.addEventListener('touchend', () => finishSwipe(false), {
          passive: true,
        });

        mainMedia.addEventListener('touchcancel', () => finishSwipe(true), {
          passive: true,
        });
      }

      if (mainMedia) {
        if ('IntersectionObserver' in window) {
          const galleryVisibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.06 &&
                  document.visibilityState !== 'hidden';

                mainMedia.dataset.fb3Visible = visible ? 'true' : 'false';

                if (visible) {
                  activatePanelMedia(mediaPanels[activeMediaIndex]);
                } else {
                  mediaPanels.forEach((panel) => pausePanelVideos(panel));
                }
              });
            },
            {
              threshold: [0, 0.06, 0.2],
              rootMargin: '30px 0px',
            }
          );

          galleryVisibilityObserver.observe(mainMedia);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              mainMedia.dataset.fb3Visible = 'false';
              mediaPanels.forEach((panel) => pausePanelVideos(panel));
              return;
            }

            const rect = mainMedia.getBoundingClientRect();
            const visible =
              rect.bottom > 0 &&
              rect.top < window.innerHeight &&
              rect.right > 0 &&
              rect.left < window.innerWidth;

            mainMedia.dataset.fb3Visible = visible ? 'true' : 'false';

            if (visible) {
              activatePanelMedia(mediaPanels[activeMediaIndex]);
            }
          });
        } else {
          mainMedia.dataset.fb3Visible = 'true';
        }
      }

      if (mediaPanels.length > 0) {
        setActiveMedia(activeMediaIndex);
      }

      const autoplayVideos = Array.from(
        root.querySelectorAll('[data-fb3-autoplay-video]')
      );

      const setLoopingVideoState = (video, shouldPlay) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');

        if (!shouldPlay) {
          video.pause();
          return;
        }

        video.preload = 'metadata';
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      autoplayVideos.forEach((video) => {
        setLoopingVideoState(video, false);
      });

      if (autoplayVideos.length > 0) {
        if ('IntersectionObserver' in window) {
          const loopingVideoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const shouldPlay =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.12 &&
                  document.visibilityState !== 'hidden';

                setLoopingVideoState(entry.target, shouldPlay);
              });
            },
            {
              threshold: [0, 0.12, 0.35],
              rootMargin: '80px 0px',
            }
          );

          autoplayVideos.forEach((video) => loopingVideoObserver.observe(video));

          document.addEventListener('visibilitychange', () => {
            autoplayVideos.forEach((video) => {
              if (document.visibilityState === 'hidden') {
                setLoopingVideoState(video, false);
                return;
              }

              const rect = video.getBoundingClientRect();
              const visible =
                rect.bottom > 0 &&
                rect.top < window.innerHeight &&
                rect.right > 0 &&
                rect.left < window.innerWidth;

              setLoopingVideoState(video, visible);
            });
          });
        } else {
          autoplayVideos.forEach((video) => setLoopingVideoState(video, true));
        }
      }

      const faq = root.querySelector('.fb3-faq');

      if (faq) {
        const faqItems = Array.from(faq.querySelectorAll('.fb3-faq-item'));
        const closingStates = new WeakMap();
        const faqTransitionDuration = 380;

        const cancelScheduledClose = (item) => {
          const state = closingStates.get(item);
          if (!state) return;

          state.panel.removeEventListener('transitionend', state.onTransitionEnd);
          window.clearTimeout(state.timeoutId);
          closingStates.delete(item);
        };

        const finalizeFaqClose = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-open', 'is-closing');
          item.removeAttribute('open');
        };

        const openFaqItem = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-closing');

          if (!item.open) {
            item.setAttribute('open', '');
          }

          if (reducedMotionQuery.matches) {
            item.classList.add('is-open');
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.add('is-open');
            });
          });
        };

        const closeFaqItem = (item) => {
          if (!item.open) return;

          cancelScheduledClose(item);
          item.classList.add('is-closing');
          item.classList.remove('is-open');

          if (reducedMotionQuery.matches) {
            finalizeFaqClose(item);
            return;
          }

          const panel = item.querySelector('.fb3-faq-panel');
          if (!panel) {
            finalizeFaqClose(item);
            return;
          }

          const onTransitionEnd = (event) => {
            if (
              event.target === panel &&
              event.propertyName === 'grid-template-rows'
            ) {
              finalizeFaqClose(item);
            }
          };

          panel.addEventListener('transitionend', onTransitionEnd);

          const timeoutId = window.setTimeout(
            () => finalizeFaqClose(item),
            faqTransitionDuration
          );

          closingStates.set(item, {
            panel,
            onTransitionEnd,
            timeoutId,
          });
        };

        faqItems.forEach((item) => {
          if (item.open) {
            item.classList.add('is-open');
          }
        });

        faq.addEventListener('click', (event) => {
          const summary = event.target.closest('.fb3-faq-item > summary');
          if (!summary || !faq.contains(summary)) return;

          event.preventDefault();

          const selectedItem = summary.parentElement;
          const selectedIsOpen =
            selectedItem.open &&
            selectedItem.classList.contains('is-open') &&
            !selectedItem.classList.contains('is-closing');

          faqItems.forEach((item) => {
            if (item !== selectedItem && item.open) {
              closeFaqItem(item);
            }
          });

          if (selectedIsOpen) {
            closeFaqItem(selectedItem);
          } else {
            openFaqItem(selectedItem);
          }
        });
      }

      const variantsScript = root.querySelector('[data-flex3-variants]');
      const form = root.querySelector('.fb3-product-form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.warn('Flex Buybox3: Variantendaten konnten nicht gelesen werden.', error);
        return;
      }

      const idInput = form.querySelector('[data-variant-id]');
      const optionSelects = form.querySelectorAll('[data-option-position]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addButtonText = form.querySelector('[data-add-button-text]');
      const directCheckoutButton = form.querySelector('[data-direct-checkout]');
      const directCheckoutText = form.querySelector('[data-direct-checkout-text]');
      const directCheckoutStatus = form.querySelector('[data-direct-checkout-status]');
      const priceElement = root.querySelector('[data-product-price]');
      const comparePriceElement = root.querySelector('[data-compare-price]');
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || 'de-DE';
      const updateUrl = root.dataset.updateVariantUrl === 'true';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      let internalVariantUpdate = false;

      const updateVariant = (variant, { syncInput = true } = {}) => {
        if (!variant || !idInput) return;

        if (syncInput) {
          internalVariantUpdate = true;
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          internalVariantUpdate = false;
        }

        if (priceElement) priceElement.textContent = formatMoney(variant.price);

        if (comparePriceElement) {
          const showCompare = Number(variant.compare_at_price) > Number(variant.price);
          comparePriceElement.classList.toggle('is-hidden', !showCompare);
          comparePriceElement.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        }

        if (addButton && addButtonText) {
          addButton.disabled = !variant.available;
          addButtonText.textContent = variant.available
            ? addButton.dataset.availableText
            : addButton.dataset.soldoutText;
        }

        if (directCheckoutButton) {
          directCheckoutButton.disabled = !variant.available;
        }

        const featuredMediaId =
          variant.featured_media && (variant.featured_media.id || variant.featured_media);
        if (featuredMediaId) showMedia(featuredMediaId);

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant },
          })
        );
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(optionSelects)
            .sort(
              (a, b) =>
                Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
            )
            .map((input) => input.value);

          const matchedVariant = variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          updateVariant(matchedVariant);
        });
      });

      if (idInput) {
        idInput.addEventListener('change', () => {
          if (internalVariantUpdate) return;
          const matchedVariant = variants.find(
            (variant) => String(variant.id) === String(idInput.value)
          );
          if (matchedVariant) updateVariant(matchedVariant, { syncInput: false });
        });
      }

      /*
        Eigener Direkt-zur-Kasse-Button.

        Der Button löst bewusst denselben vorhandenen Warenkorb-Button aus,
        damit Kaching weiterhin die aktuell ausgewählte Bundle-, Seiten- und
        Größenkombination verarbeitet. Sobald Shopify die Änderung im Warenkorb
        bestätigt, wird unmittelbar zum Checkout weitergeleitet.
      */
      if (directCheckoutButton && addButton) {
        let directCheckoutRunning = false;
        let checkoutTransitionOverlay = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const ensureCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay && document.body.contains(checkoutTransitionOverlay)) {
            return checkoutTransitionOverlay;
          }

          checkoutTransitionOverlay = document.createElement('div');
          checkoutTransitionOverlay.className = 'fb3-checkout-transition-overlay';
          checkoutTransitionOverlay.setAttribute('role', 'status');
          checkoutTransitionOverlay.setAttribute('aria-live', 'polite');
          checkoutTransitionOverlay.setAttribute('aria-label', 'Weiterleitung zum Checkout');
          checkoutTransitionOverlay.innerHTML = `
            <div class="fb3-checkout-transition-card">
              <span class="fb3-checkout-transition-spinner" aria-hidden="true"></span>
              <p class="fb3-checkout-transition-title">Weiterleitung zum sicheren Checkout …</p>
              <p class="fb3-checkout-transition-copy">Ihre ausgewählte Größe und Seite werden übernommen.</p>
            </div>
          `;

          document.body.appendChild(checkoutTransitionOverlay);
          return checkoutTransitionOverlay;
        };

        const showCheckoutTransitionOverlay = () => {
          const overlay = ensureCheckoutTransitionOverlay();

          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';

          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';

          overlay.classList.add('is-visible');
        };

        const hideCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay) {
            checkoutTransitionOverlay.classList.remove('is-visible');
          }

          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
        };

        const waitForVisiblePaint = () =>
          new Promise((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve);
            });
          });

        const setDirectCheckoutState = (loading, message = '') => {
          directCheckoutRunning = loading;
          directCheckoutButton.classList.toggle('is-loading', loading);
          directCheckoutButton.setAttribute('aria-busy', loading ? 'true' : 'false');

          /*
            Der normale Add-to-Cart-Ablauf bleibt für Kaching erhalten.
            Nur die sichtbare Warenkorb-Oberfläche wird bis zur Weiterleitung
            in den Checkout temporär unterdrückt.
          */
          document.documentElement.classList.toggle('fb3-direct-checkout-active', loading);
          if (document.body) {
            document.body.classList.toggle('fb3-direct-checkout-active', loading);
          }

          if (directCheckoutText) {
            directCheckoutText.textContent = loading
              ? directCheckoutButton.dataset.loadingText
              : directCheckoutButton.dataset.defaultText;
          }

          if (directCheckoutStatus) {
            directCheckoutStatus.textContent = message;
          }

          if (loading) {
            directCheckoutButton.disabled = true;
          } else {
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(idInput?.value)
            );
            directCheckoutButton.disabled = selectedVariant
              ? !selectedVariant.available
              : addButton.disabled;
          }
        };

        const getCartSnapshot = async () => {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
          });

          if (!response.ok) {
            throw new Error('Warenkorb konnte nicht gelesen werden.');
          }

          const cart = await response.json();

          return JSON.stringify({
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            items: (cart.items || []).map((item) => ({
              key: item.key,
              quantity: item.quantity,
              finalLinePrice: item.final_line_price,
              properties: item.properties || null,
            })),
          });
        };

        const waitForCartChange = async (beforeSnapshot, timeout = 10000) => {
          const startedAt = Date.now();

          while (Date.now() - startedAt < timeout) {
            await new Promise((resolve) => window.setTimeout(resolve, 180));

            try {
              const currentSnapshot = await getCartSnapshot();
              if (currentSnapshot !== beforeSnapshot) {
                return true;
              }
            } catch (error) {
              /* Kurze Netzwerkfehler werden bis zum Timeout erneut geprüft. */
            }
          }

          return false;
        };

        directCheckoutButton.addEventListener('click', async () => {
          if (directCheckoutRunning || addButton.disabled) return;

          setDirectCheckoutState(true, 'Ihre Auswahl wird für den Checkout vorbereitet …');
          showCheckoutTransitionOverlay();

          try {
            /*
              Zwei Render-Zyklen abwarten: Die weiße Übergangsebene ist damit
              garantiert sichtbar, bevor Kaching im Hintergrund den
              Warenkorb aktualisiert oder das Theme einen Drawer öffnet.
            */
            await waitForVisiblePaint();

            const beforeSnapshot = await getCartSnapshot();

            /*
              Der vorhandene Button bleibt die einzige Add-to-Cart-Logik.
              Dadurch bleiben Kaching-Auswahl und Bundle-Rabatt erhalten.
              Ein eventuell geöffneter Warenkorb liegt vollständig hinter der
              Übergangsebene und ist für den Kunden nicht sichtbar.
            */
            addButton.click();

            const cartChanged = await waitForCartChange(beforeSnapshot);

            if (!cartChanged) {
              throw new Error('Die Auswahl wurde nicht in den Warenkorb übernommen.');
            }

            window.location.replace('/checkout');
          } catch (error) {
            console.warn('Flex Buybox3: Direkter Checkout fehlgeschlagen.', error);
            hideCheckoutTransitionOverlay();
            setDirectCheckoutState(
              false,
              'Bitte prüfen Sie Größe, Seite und Bundle-Auswahl und versuchen Sie es erneut.'
            );
          }
        });

        window.addEventListener('pageshow', () => {
          hideCheckoutTransitionOverlay();
          setDirectCheckoutState(false, '');
        });
      }
    };

    const observedRoots = new WeakSet();
    const hydrationObservers = new WeakMap();

    const hydrateRoot = (root) => {
      if (!root || root.dataset.flexBuybox3Initialized === 'true') return;

      const observer = hydrationObservers.get(root);
      if (observer) {
        observer.disconnect();
        hydrationObservers.delete(root);
      }

      initFlexBuybox3(root);
    };

    const observeRoot = (root) => {
      if (
        !root ||
        root.dataset.flexBuybox3Initialized === 'true' ||
        observedRoots.has(root)
      ) {
        return;
      }

      observedRoots.add(root);

      const bundleTarget = root.querySelector('#bundle');
      const isHashTarget =
        window.location.hash === '#bundle' &&
        bundleTarget &&
        document.getElementById('bundle') === bundleTarget;

      if (
        isHashTarget ||
        window.Shopify?.designMode ||
        !('IntersectionObserver' in window)
      ) {
        hydrateRoot(root);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            hydrateRoot(root);
          }
        },
        {
          /*
            900 px Vorlauf: Die Buybox ist vollständig bereit, bevor der Kunde
            sie erreicht, belastet aber den initialen Seitenaufruf nicht.
          */
          rootMargin: '900px 0px',
          threshold: 0.01,
        }
      );

      hydrationObservers.set(root, observer);
      observer.observe(root);
    };

    const boot = (scope = document) => {
      if (scope.matches && scope.matches('.flex-buybox3')) {
        observeRoot(scope);
        return;
      }

      scope.querySelectorAll('.flex-buybox3').forEach(observeRoot);
    };

    const scrollToBundle = () => {
      const target = document.getElementById('bundle');
      if (!target) return;

      const root = target.closest('.flex-buybox3');
      if (root) hydrateRoot(root);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      });
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href="#bundle"]');
      if (!link) return;

      event.preventDefault();

      if (window.history?.pushState) {
        window.history.pushState(null, '', '#bundle');
      } else {
        window.location.hash = 'bundle';
      }

      scrollToBundle();
    });

    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          boot();

          if (window.location.hash === '#bundle') {
            scrollToBundle();
          }
        },
        { once: true }
      );
    } else {
      boot();

      if (window.location.hash === '#bundle') {
        scrollToBundle();
      }
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexbuyboxtest"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initKreativBuybox1 = (root) => {
      if (!root || root.dataset.kreativBuybox1Initialized === 'true') return;
      root.dataset.kreativBuybox1Initialized = 'true';

      const mediaButtons = Array.from(root.querySelectorAll('[data-media-target]'));
      const mediaPanels = Array.from(root.querySelectorAll('[data-media-id]'));
      const mainMedia = root.querySelector('.kdb1-main-media');
      const galleryImages = Array.from(
        root.querySelectorAll('.kdb1-media-panel img')
      );
      const galleryVideos = Array.from(
        root.querySelectorAll('[data-kdb1-gallery-video]')
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      const preloadGalleryImages = () => {
        galleryImages.forEach((image, index) => {
          image.loading = 'eager';

          if ('fetchPriority' in image) {
            image.fetchPriority = index === 0 ? 'high' : 'low';
          }

          const requestImage = () => {
            if (typeof image.decode === 'function') {
              image.decode().catch(() => {});
            }
          };

          if (image.complete) {
            requestImage();
          } else {
            image.addEventListener('load', requestImage, { once: true });
          }
        });
      };

      preloadGalleryImages();

      let activeMediaIndex = mediaPanels.findIndex(
        (panel) => panel.classList.contains('is-active') && !panel.hidden
      );
      let isMediaAnimating = false;
      let swipeState = null;

      if (activeMediaIndex < 0 && mediaPanels.length > 0) {
        activeMediaIndex = 0;
      }

      const wrappedMediaIndex = (index) => {
        if (!mediaPanels.length) return -1;
        return (index + mediaPanels.length) % mediaPanels.length;
      };

      const hydrateGalleryVideo = (video) => {
        if (!video || video.dataset.kdb1Hydrated === 'true') return;

        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        video.dataset.kdb1Hydrated = 'true';
        video.load();
      };

      const playGalleryVideoOnce = (video) => {
        if (!video) return;

        hydrateGalleryVideo(video);

        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.loop = false;

        const panel = video.closest('.kdb1-media-panel');
        const attemptPlay = () => {
          if (!panel || !panel.classList.contains('is-active') || panel.hidden) return;

          try {
            video.currentTime = 0;
          } catch (error) {
            /* Der Browser setzt die Startposition nach dem Laden selbst. */
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };

        if (video.readyState >= 2) {
          attemptPlay();
        } else {
          video.addEventListener('loadeddata', attemptPlay, { once: true });
        }
      };

      const playPanelVideo = (panel) => {
        if (!panel) return;
        const video = panel.querySelector('[data-kdb1-gallery-video]');
        if (video) playGalleryVideoOnce(video);
      };

      const pausePanelVideos = (panel) => {
        if (!panel) return;

        panel.querySelectorAll('video').forEach((video) => {
          video.pause();

          if (video.matches('[data-kdb1-gallery-video]')) {
            try {
              video.currentTime = 0;
            } catch (error) {
              /* Noch nicht geladene Videos benötigen keinen Reset. */
            }
          }
        });
      };

      galleryVideos.forEach((video) => {
        video.addEventListener('ended', () => {
          video.pause();
          /* Am Ende bleibt bewusst das letzte Videobild stehen. */
        });
      });

      const updateMediaButtons = (activeIndex) => {
        const activeId = mediaPanels[activeIndex]?.dataset.mediaId;

        mediaButtons.forEach((button) => {
          const active = String(button.dataset.mediaTarget) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const resetPanelStyles = (panel) => {
        if (!panel) return;
        panel.classList.remove('is-media-animating');
        panel.style.transform = '';
      };

      const setActiveMedia = (targetIndex) => {
        if (targetIndex < 0 || !mediaPanels[targetIndex]) return;

        mediaPanels.forEach((panel, index) => {
          const active = index === targetIndex;

          resetPanelStyles(panel);
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            pausePanelVideos(panel);
          }
        });

        activeMediaIndex = targetIndex;
        updateMediaButtons(targetIndex);
        playPanelVideo(mediaPanels[targetIndex]);
      };

      const finishMediaAnimation = (panel, callback) => {
        let completed = false;

        const finish = () => {
          if (completed) return;
          completed = true;
          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.propertyName === 'transform') {
            finish();
          }
        };

        panel.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 460);
      };

      const animateMediaTo = (targetIndex, direction) => {
        if (
          isMediaAnimating ||
          targetIndex < 0 ||
          targetIndex === activeMediaIndex ||
          !mediaPanels[targetIndex]
        ) {
          return;
        }

        if (!mobileMediaQuery.matches || reducedMotionQuery.matches) {
          setActiveMedia(targetIndex);
          return;
        }

        const currentPanel = mediaPanels[activeMediaIndex];
        const targetPanel = mediaPanels[targetIndex];
        const slideDirection = direction >= 0 ? 1 : -1;

        isMediaAnimating = true;
        targetPanel.hidden = false;
        targetPanel.setAttribute('aria-hidden', 'false');
        currentPanel.classList.add('is-media-animating');
        targetPanel.classList.add('is-media-animating');

        currentPanel.style.transform = 'translate3d(0, 0, 0)';
        targetPanel.style.transform = `translate3d(${slideDirection * 100}%, 0, 0)`;

        targetPanel.getBoundingClientRect();

        requestAnimationFrame(() => {
          currentPanel.style.transform = `translate3d(${-slideDirection * 100}%, 0, 0)`;
          targetPanel.style.transform = 'translate3d(0, 0, 0)';
        });

        finishMediaAnimation(targetPanel, () => {
          currentPanel.hidden = true;
          currentPanel.classList.remove('is-active');
          currentPanel.setAttribute('aria-hidden', 'true');
          pausePanelVideos(currentPanel);

          resetPanelStyles(currentPanel);
          resetPanelStyles(targetPanel);
          targetPanel.hidden = false;
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');

          activeMediaIndex = targetIndex;
          updateMediaButtons(targetIndex);
          playPanelVideo(targetPanel);
          isMediaAnimating = false;
        });
      };

      const showMedia = (mediaId, options = {}) => {
        if (!mediaId) return;

        const targetIndex = mediaPanels.findIndex(
          (panel) => String(panel.dataset.mediaId) === String(mediaId)
        );

        if (targetIndex < 0 || targetIndex === activeMediaIndex) return;

        if (options.animate === true) {
          const direction = targetIndex > activeMediaIndex ? 1 : -1;
          animateMediaTo(targetIndex, direction);
        } else {
          setActiveMedia(targetIndex);
        }
      };

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMedia(button.dataset.mediaTarget, { animate: true });
        });
      });

      if (mainMedia && mediaPanels.length > 1) {
        mainMedia.addEventListener('dragstart', (event) => event.preventDefault());

        mainMedia.addEventListener(
          'touchstart',
          (event) => {
            if (
              !mobileMediaQuery.matches ||
              isMediaAnimating ||
              event.touches.length !== 1
            ) {
              return;
            }

            const touch = event.touches[0];

            swipeState = {
              startX: touch.clientX,
              startY: touch.clientY,
              currentX: touch.clientX,
              startTime: performance.now(),
              horizontal: null,
              direction: 0,
              targetIndex: -1,
              targetPanel: null,
            };
          },
          { passive: true }
        );

        mainMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeState || event.touches.length !== 1 || isMediaAnimating) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - swipeState.startX;
            const deltaY = touch.clientY - swipeState.startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            swipeState.currentX = touch.clientX;

            if (swipeState.horizontal === null) {
              if (Math.max(absoluteX, absoluteY) < 7) return;

              swipeState.horizontal = absoluteX > absoluteY;

              if (!swipeState.horizontal) {
                swipeState = null;
                return;
              }

              mainMedia.classList.add('is-swiping');
            }

            if (!swipeState.horizontal) return;

            event.preventDefault();

            const direction = deltaX < 0 ? 1 : -1;
            const targetIndex = wrappedMediaIndex(activeMediaIndex + direction);
            const currentPanel = mediaPanels[activeMediaIndex];

            if (
              direction !== swipeState.direction ||
              targetIndex !== swipeState.targetIndex
            ) {
              if (swipeState.targetPanel) {
                pausePanelVideos(swipeState.targetPanel);
                resetPanelStyles(swipeState.targetPanel);
                swipeState.targetPanel.hidden = true;
                swipeState.targetPanel.setAttribute('aria-hidden', 'true');
              }

              swipeState.direction = direction;
              swipeState.targetIndex = targetIndex;
              swipeState.targetPanel = mediaPanels[targetIndex];
              swipeState.targetPanel.hidden = false;
              swipeState.targetPanel.setAttribute('aria-hidden', 'false');
            }

            const width = mainMedia.clientWidth || 1;
            currentPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
            swipeState.targetPanel.style.transform =
              `translate3d(${direction * width + deltaX}px, 0, 0)`;
          },
          { passive: false }
        );

        const finishSwipe = (cancelled = false) => {
          if (!swipeState) return;

          const state = swipeState;
          swipeState = null;
          mainMedia.classList.remove('is-swiping');

          if (!state.horizontal || !state.targetPanel) {
            return;
          }

          const currentPanel = mediaPanels[activeMediaIndex];
          const targetPanel = state.targetPanel;
          const width = mainMedia.clientWidth || 1;
          const deltaX = state.currentX - state.startX;
          const elapsed = Math.max(performance.now() - state.startTime, 1);
          const velocity = Math.abs(deltaX) / elapsed;
          const shouldChange =
            !cancelled &&
            (Math.abs(deltaX) >= Math.min(58, width * 0.18) || velocity > 0.45);

          isMediaAnimating = true;
          currentPanel.classList.add('is-media-animating');
          targetPanel.classList.add('is-media-animating');

          requestAnimationFrame(() => {
            if (shouldChange) {
              currentPanel.style.transform =
                `translate3d(${-state.direction * width}px, 0, 0)`;
              targetPanel.style.transform = 'translate3d(0, 0, 0)';
            } else {
              currentPanel.style.transform = 'translate3d(0, 0, 0)';
              targetPanel.style.transform =
                `translate3d(${state.direction * width}px, 0, 0)`;
            }
          });

          finishMediaAnimation(shouldChange ? targetPanel : currentPanel, () => {
            resetPanelStyles(currentPanel);
            resetPanelStyles(targetPanel);

            if (shouldChange) {
              currentPanel.hidden = true;
              currentPanel.classList.remove('is-active');
              currentPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(currentPanel);

              targetPanel.hidden = false;
              targetPanel.classList.add('is-active');
              targetPanel.setAttribute('aria-hidden', 'false');

              activeMediaIndex = state.targetIndex;
              updateMediaButtons(activeMediaIndex);
              playPanelVideo(targetPanel);
            } else {
              currentPanel.hidden = false;
              currentPanel.classList.add('is-active');
              currentPanel.setAttribute('aria-hidden', 'false');

              targetPanel.hidden = true;
              targetPanel.classList.remove('is-active');
              targetPanel.setAttribute('aria-hidden', 'true');
              pausePanelVideos(targetPanel);
            }

            isMediaAnimating = false;
          });
        };

        mainMedia.addEventListener('touchend', () => finishSwipe(false), {
          passive: true,
        });

        mainMedia.addEventListener('touchcancel', () => finishSwipe(true), {
          passive: true,
        });
      }

      if (mediaPanels.length > 0) {
        setActiveMedia(activeMediaIndex);
      }

      const autoplayVideos = Array.from(root.querySelectorAll('[data-kdb1-autoplay-video]'));

      const startAutoplayVideos = () => {
        autoplayVideos.forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      };

      autoplayVideos.forEach((video) => {
        video.addEventListener('loadeddata', startAutoplayVideos, { once: true });
      });

      startAutoplayVideos();

      const faq = root.querySelector('.kdb1-faq');

      if (faq) {
        const faqItems = Array.from(faq.querySelectorAll('.kdb1-faq-item'));
        const closingStates = new WeakMap();
        const faqTransitionDuration = 380;

        const cancelScheduledClose = (item) => {
          const state = closingStates.get(item);
          if (!state) return;

          state.panel.removeEventListener('transitionend', state.onTransitionEnd);
          window.clearTimeout(state.timeoutId);
          closingStates.delete(item);
        };

        const finalizeFaqClose = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-open', 'is-closing');
          item.removeAttribute('open');
        };

        const openFaqItem = (item) => {
          cancelScheduledClose(item);
          item.classList.remove('is-closing');

          if (!item.open) {
            item.setAttribute('open', '');
          }

          if (reducedMotionQuery.matches) {
            item.classList.add('is-open');
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.add('is-open');
            });
          });
        };

        const closeFaqItem = (item) => {
          if (!item.open) return;

          cancelScheduledClose(item);
          item.classList.add('is-closing');
          item.classList.remove('is-open');

          if (reducedMotionQuery.matches) {
            finalizeFaqClose(item);
            return;
          }

          const panel = item.querySelector('.kdb1-faq-panel');
          if (!panel) {
            finalizeFaqClose(item);
            return;
          }

          const onTransitionEnd = (event) => {
            if (
              event.target === panel &&
              event.propertyName === 'grid-template-rows'
            ) {
              finalizeFaqClose(item);
            }
          };

          panel.addEventListener('transitionend', onTransitionEnd);

          const timeoutId = window.setTimeout(
            () => finalizeFaqClose(item),
            faqTransitionDuration
          );

          closingStates.set(item, {
            panel,
            onTransitionEnd,
            timeoutId,
          });
        };

        faqItems.forEach((item) => {
          if (item.open) {
            item.classList.add('is-open');
          }
        });

        faq.addEventListener('click', (event) => {
          const summary = event.target.closest('.kdb1-faq-item > summary');
          if (!summary || !faq.contains(summary)) return;

          event.preventDefault();

          const selectedItem = summary.parentElement;
          const selectedIsOpen =
            selectedItem.open &&
            selectedItem.classList.contains('is-open') &&
            !selectedItem.classList.contains('is-closing');

          faqItems.forEach((item) => {
            if (item !== selectedItem && item.open) {
              closeFaqItem(item);
            }
          });

          if (selectedIsOpen) {
            closeFaqItem(selectedItem);
          } else {
            openFaqItem(selectedItem);
          }
        });
      }

      const variantsScript = root.querySelector('[data-kdb1-variants]');
      const form = root.querySelector('.kdb1-product-form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.warn('Flex Buybox: Variantendaten konnten nicht gelesen werden.', error);
        return;
      }

      const idInput = form.querySelector('[data-variant-id]');
      const optionSelects = form.querySelectorAll('[data-option-position]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const addButtonText = form.querySelector('[data-add-button-text]');
      const directCheckoutButton = form.querySelector('[data-direct-checkout]');
      const directCheckoutText = form.querySelector('[data-direct-checkout-text]');
      const directCheckoutStatus = form.querySelector('[data-direct-checkout-status]');
      const priceElement = root.querySelector('[data-product-price]');
      const comparePriceElement = root.querySelector('[data-compare-price]');
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || 'de-DE';
      const updateUrl = root.dataset.updateVariantUrl === 'true';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
        }
      };

      let internalVariantUpdate = false;

      const updateVariant = (variant, { syncInput = true } = {}) => {
        if (!variant || !idInput) return;

        if (syncInput) {
          internalVariantUpdate = true;
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          internalVariantUpdate = false;
        }

        if (priceElement) priceElement.textContent = formatMoney(variant.price);

        if (comparePriceElement) {
          const showCompare = Number(variant.compare_at_price) > Number(variant.price);
          comparePriceElement.classList.toggle('is-hidden', !showCompare);
          comparePriceElement.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        }

        if (addButton && addButtonText) {
          addButton.disabled = !variant.available;
          addButtonText.textContent = variant.available
            ? addButton.dataset.availableText
            : addButton.dataset.soldoutText;
        }

        if (directCheckoutButton) {
          directCheckoutButton.disabled = !variant.available;
        }

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant },
          })
        );
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(optionSelects)
            .sort(
              (a, b) =>
                Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
            )
            .map((input) => input.value);

          const matchedVariant = variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          updateVariant(matchedVariant);
        });
      });

      if (idInput) {
        idInput.addEventListener('change', () => {
          if (internalVariantUpdate) return;
          const matchedVariant = variants.find(
            (variant) => String(variant.id) === String(idInput.value)
          );
          if (matchedVariant) updateVariant(matchedVariant, { syncInput: false });
        });
      }

      /*
        Eigener Direkt-zur-Kasse-Button.

        Der Button löst bewusst denselben vorhandenen Warenkorb-Button aus,
        damit Kaching weiterhin die aktuell ausgewählte Bundle-, Seiten- und
        Größenkombination verarbeitet. Sobald Shopify die Änderung im Warenkorb
        bestätigt, wird unmittelbar zum Checkout weitergeleitet.
      */
      if (directCheckoutButton && addButton) {
        let directCheckoutRunning = false;
        let checkoutTransitionOverlay = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const ensureCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay && document.body.contains(checkoutTransitionOverlay)) {
            return checkoutTransitionOverlay;
          }

          checkoutTransitionOverlay = document.createElement('div');
          checkoutTransitionOverlay.className = 'kdb1-checkout-transition-overlay';
          checkoutTransitionOverlay.setAttribute('role', 'status');
          checkoutTransitionOverlay.setAttribute('aria-live', 'polite');
          checkoutTransitionOverlay.setAttribute('aria-label', 'Weiterleitung zum Checkout');
          checkoutTransitionOverlay.innerHTML = `
            <div class="kdb1-checkout-transition-card">
              <span class="kdb1-checkout-transition-spinner" aria-hidden="true"></span>
              <p class="kdb1-checkout-transition-title">Weiterleitung zum sicheren Checkout …</p>
              <p class="kdb1-checkout-transition-copy">Ihre ausgewählte Größe und Seite werden übernommen.</p>
            </div>
          `;

          document.body.appendChild(checkoutTransitionOverlay);
          return checkoutTransitionOverlay;
        };

        const showCheckoutTransitionOverlay = () => {
          const overlay = ensureCheckoutTransitionOverlay();

          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';

          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';

          overlay.classList.add('is-visible');
        };

        const hideCheckoutTransitionOverlay = () => {
          if (checkoutTransitionOverlay) {
            checkoutTransitionOverlay.classList.remove('is-visible');
          }

          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
        };

        const waitForVisiblePaint = () =>
          new Promise((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve);
            });
          });

        const setDirectCheckoutState = (loading, message = '') => {
          directCheckoutRunning = loading;
          directCheckoutButton.classList.toggle('is-loading', loading);
          directCheckoutButton.setAttribute('aria-busy', loading ? 'true' : 'false');

          /*
            Der normale Add-to-Cart-Ablauf bleibt für Kaching erhalten.
            Nur die sichtbare Warenkorb-Oberfläche wird bis zur Weiterleitung
            in den Checkout temporär unterdrückt.
          */
          document.documentElement.classList.toggle('kdb1-direct-checkout-active', loading);
          if (document.body) {
            document.body.classList.toggle('kdb1-direct-checkout-active', loading);
          }

          if (directCheckoutText) {
            directCheckoutText.textContent = loading
              ? directCheckoutButton.dataset.loadingText
              : directCheckoutButton.dataset.defaultText;
          }

          if (directCheckoutStatus) {
            directCheckoutStatus.textContent = message;
          }

          if (loading) {
            directCheckoutButton.disabled = true;
          } else {
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(idInput?.value)
            );
            directCheckoutButton.disabled = selectedVariant
              ? !selectedVariant.available
              : addButton.disabled;
          }
        };

        const getCartSnapshot = async () => {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
          });

          if (!response.ok) {
            throw new Error('Warenkorb konnte nicht gelesen werden.');
          }

          const cart = await response.json();

          return JSON.stringify({
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            items: (cart.items || []).map((item) => ({
              key: item.key,
              quantity: item.quantity,
              finalLinePrice: item.final_line_price,
              properties: item.properties || null,
            })),
          });
        };

        const waitForCartChange = async (beforeSnapshot, timeout = 10000) => {
          const startedAt = Date.now();

          while (Date.now() - startedAt < timeout) {
            await new Promise((resolve) => window.setTimeout(resolve, 180));

            try {
              const currentSnapshot = await getCartSnapshot();
              if (currentSnapshot !== beforeSnapshot) {
                return true;
              }
            } catch (error) {
              /* Kurze Netzwerkfehler werden bis zum Timeout erneut geprüft. */
            }
          }

          return false;
        };

        directCheckoutButton.addEventListener('click', async () => {
          if (directCheckoutRunning || addButton.disabled) return;

          setDirectCheckoutState(true, 'Ihre Auswahl wird für den Checkout vorbereitet …');
          showCheckoutTransitionOverlay();

          try {
            /*
              Zwei Render-Zyklen abwarten: Die weiße Übergangsebene ist damit
              garantiert sichtbar, bevor Kaching im Hintergrund den
              Warenkorb aktualisiert oder das Theme einen Drawer öffnet.
            */
            await waitForVisiblePaint();

            const beforeSnapshot = await getCartSnapshot();

            /*
              Der vorhandene Button bleibt die einzige Add-to-Cart-Logik.
              Dadurch bleiben Kaching-Auswahl und Bundle-Rabatt erhalten.
              Ein eventuell geöffneter Warenkorb liegt vollständig hinter der
              Übergangsebene und ist für den Kunden nicht sichtbar.
            */
            addButton.click();

            const cartChanged = await waitForCartChange(beforeSnapshot);

            if (!cartChanged) {
              throw new Error('Die Auswahl wurde nicht in den Warenkorb übernommen.');
            }

            window.location.replace('/checkout');
          } catch (error) {
            console.warn('Kreativ Buybox1: Direkter Checkout fehlgeschlagen.', error);
            hideCheckoutTransitionOverlay();
            setDirectCheckoutState(
              false,
              'Bitte prüfen Sie Größe, Seite und Bundle-Auswahl und versuchen Sie es erneut.'
            );
          }
        });

        window.addEventListener('pageshow', () => {
          hideCheckoutTransitionOverlay();
          setDirectCheckoutState(false, '');
        });
      }
    };

    const boot = (scope = document) => {
      if (scope.matches && scope.matches('.kreativ-buybox1')) {
        initKreativBuybox1(scope);
        return;
      }

      scope.querySelectorAll('.kreativ-buybox1').forEach(initKreativBuybox1);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
